(function () {
  if (typeof window.fetch === 'function') {
    if (!window.__vrvTrueNativeFetch) {
      window.__vrvTrueNativeFetch = window.fetch.bind(window);
    }
    if (!window.__vrvNativeFetch) {
      window.__vrvNativeFetch = window.__vrvTrueNativeFetch;
    }
  }

  function getTrueNativeFetch() {
    return (
      window.__vrvTrueNativeFetch ||
      window.__vrvNativeFetch ||
      (typeof window.fetch === 'function' ? window.fetch.bind(window) : null)
    );
  }

  function vrvFetch(url, options) {
    const fn = getTrueNativeFetch();
    if (!fn) return Promise.reject(new Error('fetch unavailable'));
    return fn(url, options);
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartPageSectionId() {
    const cartItems = document.getElementById('main-cart-items');
    return cartItems && cartItems.dataset.id ? cartItems.dataset.id : null;
  }

  function getSectionIds() {
    const pageSection = getCartPageSectionId();
    if (pageSection) {
      return [pageSection, 'cart-icon-bubble', 'cart-drawer'];
    }
    const drawer = getCartDrawer();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map((s) => s.section || s.id);
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function buildCartUpdateBody(fields) {
    const body = Object.assign({}, fields);
    const sectionIds = getSectionIds();
    if (sectionIds && sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  function isCartDiscountCode(d) {
    return d && d.target_type !== 'shipping_line' && d.type === 'discount_code';
  }

  function cartHasAttachedDiscountCode(data) {
    const codes = (data && data.discount_codes) || [];
    return codes.some((c) => c && c.code && c.applicable !== false);
  }

  function cartHasAutomaticDiscount(data) {
    const apps = (data && data.discount_applications) || [];
    return apps.some(
      (d) =>
        d &&
        d.target_type !== 'shipping_line' &&
        d.total_allocated_amount > 0 &&
        (d.type === 'automatic' || d.type === 'script')
    );
  }

  function cartHasActiveDiscount(data) {
    if (!data) return false;
    if (typeof data.total_discount === 'number' && data.total_discount > 0) return true;
    const apps = data.discount_applications || [];
    return apps.some(
      (d) => d && d.target_type !== 'shipping_line' && d.total_allocated_amount > 0
    );
  }

  let _vrvCartJsInflight = null;
  let _vrvCartJsLastAt = 0;
  const CART_JS_DEDUPE_MS = 1200;

  function invalidateCartJsCache() {
    _vrvCartJsInflight = null;
    _vrvCartJsLastAt = 0;
    _vrvLastKnownValidCart = null;
  }

  // FIX (root cause of "removed item sometimes reappears, cart count goes
  // stale"): fetchCartRaw()/fetchFreshCart() below dedupe repeated /cart.js
  // calls for up to CART_JS_DEDUPE_MS (1.2s) by handing out the SAME
  // in-flight/just-resolved promise to every caller in that window -- correct
  // when nothing changed, wrong when something did. assets/cart.js handles
  // quantity changes and removal (CartItems.updateQuantity) in a completely
  // separate script closure with no access to invalidateCartJsCache(), so a
  // removal there could leave this cache holding a pre-removal snapshot for
  // up to 1.2s. Anything in THIS file that called fetchFreshCart() during
  // that window (gift-wrap integrity checks, pricing sync, discount cleanup,
  // etc. -- there are many) would render that stale snapshot, which is what
  // made a just-removed line look like it "came back" and the header count
  // look wrong. Exposed globally so cart.js can invalidate it the moment a
  // removal/quantity change is confirmed by the server, same as the existing
  // bustCache:true path already does internally.
  window.vrvInvalidateCartJsCache = invalidateCartJsCache;

  let _vrvCartRequestVersion = 0;
  let _vrvLastKnownValidCart = null;

  function setCurrentCart(cart) {
    if (!cart || typeof cart !== 'object') return;
    // An /cart/add.js response ({ items: [only the added lines] }) is not the
    // cart. Treating it as one made anything reading the cached cart in the next
    // 1.2s (Buy Now snapshot, gift-wrap sync, pricing) see missing items.
    if (typeof cart.item_count !== 'number' || !Array.isArray(cart.items)) {
      invalidateCartJsCache();
      return;
    }
    _vrvLastKnownValidCart = cart;
    _vrvCartJsInflight = Promise.resolve(cart);
    _vrvCartJsLastAt = Date.now();
    syncCartPricingUI(cart);
  }
  window.vrvSetCurrentCart = setCurrentCart;

  function fetchCartJsFromNetwork() {
    const fn = getTrueNativeFetch();
    if (!fn) return Promise.resolve(_vrvLastKnownValidCart);
    const requestVersion = ++_vrvCartRequestVersion;
    const url = '/cart.js?_t=' + Date.now();
    return fn(url, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (cart && typeof cart.item_count === 'number') {
          _vrvLastKnownValidCart = cart;
        }
        if (requestVersion !== _vrvCartRequestVersion) {
          return _vrvLastKnownValidCart || cart;
        }
        return cart || _vrvLastKnownValidCart;
      })
      .catch(() => _vrvLastKnownValidCart);
  }

  function fetchCartNow() {
    return fetchFreshCart();
  }

  /** Unpatched /cart.js — real Shopify totals (required before Razorpay checkout). */
  function fetchCartRaw(options) {
    const bustCache = options && options.bustCache;

    if (bustCache) {
      invalidateCartJsCache();
      return fetchCartJsFromNetwork();
    }

    const now = Date.now();
    if (_vrvCartJsInflight && now - _vrvCartJsLastAt < CART_JS_DEDUPE_MS) {
      return _vrvCartJsInflight;
    }

    _vrvCartJsLastAt = now;
    _vrvCartJsInflight = fetchCartJsFromNetwork()
      .then((cart) => cart || null)
      .catch(() => null)
      .finally(() => {
        setTimeout(() => {
          if (_vrvCartJsInflight) _vrvCartJsInflight = null;
        }, CART_JS_DEDUPE_MS);
      });
    return _vrvCartJsInflight;
  }

  function fetchFreshCart() {
    return fetchCartRaw();
  }

  function clearCartDiscountCodes() {
    const sectionIds = getSectionIds();
    const body = { discount: '' };
    if (sectionIds && sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    return vrvFetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((data) => {
        invalidateCartJsCache();
        return data;
      });
  }

  /** True when Shopify accepted the code (discount_codes or discount_applications). */
  function normalizeDiscountCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function codeMatchesDiscountLabel(needle, label) {
    const n = String(needle || '').trim().toLowerCase();
    const t = String(label || '').trim().toLowerCase();
    if (!n || !t) return false;
    if (t === n) return true;
    if (t.includes(n)) return true;
    if (n.includes(t)) return true;
    return false;
  }

  function cartHasLineLevelDiscount(cart, code) {
    if (!cart || !code) return false;
    const needle = String(code).trim().toLowerCase();
    const items = cart.items || [];

    for (const item of items) {
      const discounts = item.discounts || [];
      if (
        discounts.some(
          (d) => d && d.amount > 0 && codeMatchesDiscountLabel(needle, d.title)
        )
      ) {
        return true;
      }

      const allocs = item.line_level_discount_allocations || [];
      for (const alloc of allocs) {
        const app = alloc && alloc.discount_application;
        if (!app || !alloc.amount) continue;
        if (codeMatchesDiscountLabel(needle, app.title)) return true;
      }
    }

    return false;
  }

  function discountLooksApplied(data, code) {
    const needle = String(code || '').trim().toLowerCase();
    if (!needle) return false;

    const codes = (data && data.discount_codes) || [];
    if (
      codes.some(
        (c) => c && c.code && c.code.toLowerCase() === needle && c.applicable !== false
      )
    ) {
      return true;
    }

    const apps = (data && data.discount_applications) || [];
    if (
      apps.some((d) => {
        if (!d || d.target_type === 'shipping_line') return false;
        if (!d.total_allocated_amount || d.total_allocated_amount <= 0) return false;
        return codeMatchesDiscountLabel(needle, d.title);
      })
    ) {
      return true;
    }

    const levelApps = (data && data.cart_level_discount_applications) || [];
    return levelApps.some((d) => {
      if (!d || d.target_type === 'shipping_line') return false;
      return codeMatchesDiscountLabel(needle, d.title || d.code);
    });
  }

  function discountEffectivelyActive(data, code) {
    if (discountLooksApplied(data, code)) return true;
    return cartHasLineLevelDiscount(data, code);
  }

  function cartAlreadyHasDiscountCode(cart, code) {
    if (!cart || !code) return false;
    return discountEffectivelyActive(cart, code);
  }

  function prepareCartForDiscountApply(code) {
    const normalized = normalizeDiscountCode(code);
    return fetchFreshCart().then((cart) => {
      if (cart && cartAlreadyHasDiscountCode(cart, normalized)) {
        return { cart, normalized, alreadyApplied: true };
      }

      if (!cart || !cartHasAttachedDiscountCode(cart)) {
        return { cart, normalized, alreadyApplied: false, skipClear: true };
      }

      return clearCartDiscountCodes()
        .catch(() => null)
        .then(() => ({ cart: null, normalized, alreadyApplied: false, skipClear: false }));
    });
  }

  /**
   * Persists which coupon the customer actually asked for as a cart
   * attribute, so Liquid (snippets/vrv-cart-drawer-offers.liquid) can still
   * recognize it as "applied" even after the combo engine
   * (assets/vrv-combo-1699.js) folds its value into a composite
   * VRVCMBO_<amount>_<hash> discount code and cart.discount_applications no
   * longer has an entry literally titled with this coupon's code.
   */
  function writeActiveCouponAttribute(code) {
    const value = code ? normalizeDiscountCode(code) : '';
    return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _vrv_active_coupon: value } }),
    })
      .then((res) => res.json())
      .catch(() => null);
  }

  function finishSuccessfulDiscountApply(data, trimmed, sourceBtn, restoreButton) {
    couponApplyCooldownUntil = Date.now() + 4000;
    setPreferredCoupon(trimmed);
    if (data) syncCartPricingUI(data);

    return writeActiveCouponAttribute(trimmed).then(() =>
      refreshCartAfterCouponChange(data, { skipAutoApply: true })
      .then(() => maintainGiftWrapDiscountIntegrity().catch(() => null))
      .then(() => {
        restoreButton();

        return fetchFreshCart()
          .then((fresh) => {
            if (fresh) syncCartPricingUI(fresh);
          })
          .then(() => {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-coupon', cartData: data });
            }
            document.dispatchEvent(
              new CustomEvent('cart:updated', { detail: Object.assign({}, data, { source: 'cart-coupon' }) })
            );

            const drawer = getCartDrawer();
            if (drawer && drawer.classList.contains('is-coupons-open')) {
              setTimeout(() => closeCouponsPage(), 650);
            }
          });
      })
    );
  }

  function drawerViewAllOffersButtonHtml() {
    return '';
  }

  function drawerCouponInputRowHtml() {
    return (
      ''
      + '<div class="vrv-drawer__coupon-input-row">'
      + '<span class="vrv-drawer__coupon-input-icon" aria-hidden="true">'
      + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b8770" stroke-width="1.8"'
      + ' stroke-linecap="round" stroke-linejoin="round">'
      + '<path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.83z"/>'
      + '<line x1="7" y1="7" x2="7.01" y2="7"/>'
      + '</svg>'
      + '</span>'
      + '<input type="text" id="CartDrawer-CouponInput" class="vrv-drawer__coupon-input"'
      + ' placeholder="Enter Coupon Code" autocomplete="off" autocapitalize="characters" spellcheck="false">'
      + '<button type="button" class="vrv-drawer__coupon-apply" data-vrv-apply-discount-input>Apply</button>'
      + '</div>'
      + '<p class="vrv-drawer__coupon-error" id="CartDrawer-CouponError" role="alert" hidden></p>'
    );
  }

  function ensureDrawerViewAllOffersButton(offersRoot) {
    return;
  }

  function refreshCartAfterCouponChange(data, options) {
    options = options || {};
    if (data) syncCartPricingUI(data);
    if (data && data.sections) {
      try {
        partialRefreshFromSections(data.sections);
      } catch (_) {
        /* partial refresh is best-effort before full drawer sync */
      }
    }
    const drawer = getCartDrawer();
    if (drawer && typeof drawer.refreshDrawer === 'function') {
      // FIX: forceFresh=true -- a coupon/discount was just applied or removed, so
      // the drawer's own hover-prefetched snapshot (valid for up to 5s, meant only
      // for "user is about to open the drawer with no known change") must never be
      // used here, or the coupon change can silently fail to appear.
      return drawer.refreshDrawer(true).then(() => {
        updateCartIconBubble(data);
        bindExtras(drawer, { skipAutoApply: options.skipAutoApply !== false });
        return fetchFreshCart().then((fresh) => {
          if (fresh) syncCartPricingUI(fresh);
        });
      });
    }
    refreshCartFromResponse(data, options);
    return fetchFreshCart().then((fresh) => {
      if (fresh) syncCartPricingUI(fresh);
    });
  }

  function refreshCartPageFromSections(sections) {
    const sectionId = getCartPageSectionId();
    if (!sectionId || !sections || !sections[sectionId]) return false;

    const doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
    const root = doc.querySelector('.shopify-section') || doc;
    const sourceItems = root.querySelector('#main-cart-items .js-contents') || root.querySelector('.js-contents');
    const liveItems = document.querySelector('#main-cart-items .js-contents');
    if (sourceItems && liveItems) {
      liveItems.innerHTML = sourceItems.innerHTML;
    }

    const sourceFooter =
      root.querySelector('#main-cart-footer .js-contents-footer') || root.querySelector('.js-contents-footer');
    const liveFooter = document.querySelector('#main-cart-footer .js-contents-footer');
    if (sourceFooter && liveFooter) {
      liveFooter.innerHTML = sourceFooter.innerHTML;
    }

    const page = document.getElementById('VrvCartPage');
    if (page) {
      const hasLines = liveItems && (liveItems.querySelector('.vrv-cart-line') || liveItems.querySelector('.vrv-cart-page__lines'));
      page.classList.toggle('vrv-cart-page--empty', !hasLines);
      page.classList.toggle('is-empty', !hasLines);
    }

    return true;
  }

  /** Partial refresh — never replace .cart__ctas or <cart-drawer-items> (keeps line items + Razorpay hooks). */
  const DRAWER_PARTIAL_SELECTORS = [
    '.vrv-drawer__items',
    '#CartDrawer-FooterTotals',
    '#CartDrawer-Pinned',
    '#CartDrawer-Offers',
    '#CartDrawer-CouponsPage',
    '#CartDrawer-Recommended',
    '.vrv-drawer__promo',
    '.vrv-drawer__header',
    '.vrv-drawer__coupon-toolbar',
    '.vrv-drawer__count',
    '.vrv-drawer__shipping-banner',
    '.vrv-drawer__savings',
    '.vrv-drawer__totals-value',
    '.vrv-cart-totals',
  ];

  function getSectionRoot(doc) {
    return doc.querySelector('.shopify-section') || doc.querySelector('#shopify-section-cart-drawer') || doc;
  }

  function updateCartIconBubble(htmlOrData) {
    const iconEl = document.getElementById('cart-icon-bubble');
    if (!iconEl) return false;

    const bubbleHtml =
      htmlOrData && htmlOrData.sections
        ? htmlOrData.sections['cart-icon-bubble']
        : typeof htmlOrData === 'string'
          ? htmlOrData
          : null;

    if (bubbleHtml) {
      const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const section =
        doc.querySelector('.shopify-section') || doc.querySelector('[id^="shopify-section-"]');
      if (section && section.innerHTML) {
        iconEl.innerHTML = section.innerHTML;
        const drawer = getCartDrawer();
        if (drawer && typeof drawer.setHeaderCartIconAccessibility === 'function') {
          drawer.setHeaderCartIconAccessibility();
        }
        return true;
      }
    }

    const count =
      htmlOrData && typeof htmlOrData.item_count === 'number'
        ? htmlOrData.item_count
        : null;
    if (count == null) return false;

    const visible = iconEl.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (visible) visible.textContent = count < 100 ? String(count) : '99+';
    const bubble = iconEl.querySelector('.cart-count-bubble');
    if (bubble) {
      if (count > 0) {
        bubble.hidden = false;
        bubble.removeAttribute('hidden');
        bubble.style.display = '';
      } else {
        bubble.hidden = true;
        bubble.style.display = 'none';
      }
    }
    return true;
  }

  /** Fetch latest cart HTML into the drawer (and bubble unless preserveBubble). */
  function syncCartDrawerFromServer(options) {
    options = options || {};

    function apply(cart) {
      const drawer = getCartDrawer();
      const count =
        cart && typeof cart.item_count === 'number'
          ? cart.item_count
          : cart && Array.isArray(cart.items)
            ? cart.items.length
            : 0;

      if (cart && !options.preserveBubble) {
        updateCartIconBubble(cart);
      }

      if (drawer) {
        drawer.classList.toggle('is-empty', count <= 0);
      }

      if (options.skipDrawerRefresh || !drawer || typeof drawer.refreshDrawer !== 'function') {
        return Promise.resolve(cart);
      }

      // FIX: forceFresh=true -- this function's whole job is "render the cart data
      // we just fetched fresh (see fetchFreshCart() below)". Without forceFresh the
      // drawer HTML could come from a stale hover-prefetched snapshot instead, so it
      // could visibly mismatch the fresh `cart` JSON this same call just used for the
      // bubble/empty-state above.
      return drawer.refreshDrawer(true).then(() => {
        enableDrawerCheckoutButton();
        if (cart && !options.preserveBubble) {
          updateCartIconBubble(cart);
        }
        return cart;
      });
    }

    if (options.cart) {
      return apply(options.cart);
    }

    return fetchFreshCart().then(apply);
  }

  window.vrvSyncCartDrawerFromServer = syncCartDrawerFromServer;

  function openCouponsPage() {
    const drawer = getCartDrawer();
    const page = document.getElementById('CartDrawer-CouponsPage');
    if (!drawer || !page) return false;

    if (!drawer.classList.contains('active') && typeof drawer.open === 'function') {
      drawer.open(document.activeElement);
    }

    page.removeAttribute('hidden');
    page.setAttribute('aria-hidden', 'false');
    page.classList.add('is-open');
    drawer.classList.add('is-coupons-open');

    const back = page.querySelector('[data-vrv-coupons-back], .vrv-cart-drawer__coupons-close');
    if (back && typeof back.focus === 'function') {
      setTimeout(() => back.focus(), 220);
    }
    document.addEventListener('keydown', couponsPageEscapeHandler);
    return true;
  }

  window.vrvOpenCouponsPage = openCouponsPage;

  // A cart refresh re-renders the drawer markup, which resets the offers page to
  // closed while the drawer still carries is-coupons-open (=> blank panel).
  // Re-open it (or drop the stale flag) after any cart update.
  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      const drawer = getCartDrawer();
      const page = document.getElementById('CartDrawer-CouponsPage');
      if (!drawer || !page || !drawer.classList.contains('is-coupons-open')) return;
      if (page.classList.contains('is-open') && !page.hasAttribute('hidden')) return;
      page.removeAttribute('hidden');
      page.setAttribute('aria-hidden', 'false');
      page.classList.add('is-open');
    }, 80);
  });

  function closeCouponsPage() {
    const drawer = getCartDrawer();
    const page = document.getElementById('CartDrawer-CouponsPage');
    if (!drawer || !page) return;
    page.classList.remove('is-open');
    drawer.classList.remove('is-coupons-open');
    page.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      if (!page.classList.contains('is-open')) page.setAttribute('hidden', '');
    }, 340);
    document.removeEventListener('keydown', couponsPageEscapeHandler);
    const toggle = drawer.querySelector('[data-vrv-open-coupons-page]');
    if (toggle && typeof toggle.focus === 'function') toggle.focus();
  }

  function couponsPageEscapeHandler(e) {
    if (e.key === 'Escape') closeCouponsPage();
  }

  async function copyDiscountCode(code, btn) {
    const raw = typeof code === 'string' ? code.trim() : '';
    if (!raw) return;
    const text = raw.toUpperCase();
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(text);
      } else {
        const input = document.createElement('input');
        input.value = text;
        input.setAttribute('readonly', 'readonly');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
      if (btn) {
        const old = btn.textContent;
        btn.textContent = 'Copied';
        btn.classList.add('is-copied');
        setTimeout(() => {
          btn.textContent = old;
          btn.classList.remove('is-copied');
        }, 1200);
      }
    } catch (_) {
      /* no-op */
    }
  }

  function cartDataIsEmpty(data) {
    if (!data || typeof data !== 'object') return false;
    if (typeof data.item_count === 'number') return data.item_count === 0;
    return Array.isArray(data.items) && data.items.length === 0;
  }

  function partialRefreshFromSections(sections) {
    const sectionHtml = sections && sections['cart-drawer'];
    if (!sectionHtml) return false;

    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const root = getSectionRoot(doc);
    const sourceDrawer = root.querySelector('cart-drawer') || doc.querySelector('cart-drawer');
    const drawerEl = getCartDrawer();
    const liveWasEmpty = Boolean(drawerEl && drawerEl.classList.contains('is-empty'));
    const sourceHasItems = Boolean(sourceDrawer && !sourceDrawer.classList.contains('is-empty'));
    const sourceLineCount = root.querySelectorAll('.vrv-drawer__items .vrv-cart-line').length;
    const sourceIsEmpty = Boolean(
      (sourceDrawer && sourceDrawer.classList.contains('is-empty')) || sourceLineCount === 0
    );

    if (drawerEl && sourceIsEmpty) {
      drawerEl.classList.add('is-empty');
      drawerEl.classList.remove('is-coupons-open');
      const couponsPage = document.getElementById('CartDrawer-CouponsPage');
      if (couponsPage) {
        couponsPage.classList.remove('is-open');
        couponsPage.setAttribute('hidden', '');
        couponsPage.setAttribute('aria-hidden', 'true');
      }
    }

    if (drawerEl?.refreshDrawer) {
      if (
        (liveWasEmpty && sourceHasItems) ||
        (!liveWasEmpty && sourceIsEmpty)
      ) {
        // FIX: forceFresh=true -- this branch only runs when the cart is transitioning
        // empty<->non-empty right after a real change, so a stale hover-prefetched
        // snapshot must never be used.
        return drawerEl.refreshDrawer(true).then(() => true);
      }
    }

    let updated = false;

    const couponsPageWasOpen = !!(drawerEl && drawerEl.classList.contains('is-coupons-open'));

    DRAWER_PARTIAL_SELECTORS.forEach((selector) => {
      const source = root.querySelector(selector);
      const target = document.querySelector(`cart-drawer ${selector}`);
      if (source && target) {
        const preserveCouponsOpen =
          selector === '#CartDrawer-CouponsPage' && target.classList.contains('is-open');
        target.innerHTML = source.innerHTML;
        if (source.className && !preserveCouponsOpen) {
          target.className = source.className;
        }
        updated = true;
      }
    });

    if (couponsPageWasOpen) {
      const newPage = document.getElementById('CartDrawer-CouponsPage');
      if (newPage) {
        newPage.hidden = false;
        newPage.classList.add('is-open');
        newPage.setAttribute('aria-hidden', 'false');
      }
      if (drawerEl) drawerEl.classList.add('is-coupons-open');
    }

    const sourceItems = root.querySelector('cart-drawer-items');
    const liveItems = document.querySelector('cart-drawer cart-drawer-items');
    if (sourceItems && liveItems) {
      const sourceList = sourceItems.querySelector('.vrv-drawer__items');
      const liveList = liveItems.querySelector('.vrv-drawer__items');
      if (sourceList && liveList) {
        liveList.innerHTML = sourceList.innerHTML;
        liveList.querySelectorAll('.vrv-cart-line--removing').forEach((line) => line.remove());
        updated = true;
      }
      liveItems.classList.toggle('is-empty', sourceItems.classList.contains('is-empty'));
    }

    const sourceDrawerEl = root.querySelector('cart-drawer') || doc.querySelector('cart-drawer');
    const liveDrawer = getCartDrawer();
    if (sourceDrawerEl && liveDrawer) {
      liveDrawer.classList.toggle('is-empty', sourceDrawerEl.classList.contains('is-empty'));
    }

    if (updated) {
      const liveDrawer = getCartDrawer();
      if (liveDrawer) hideDismissedDiscountCards(liveDrawer);
      enableDrawerCheckoutButton();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'vrv-partial-refresh' } }));
      fetchFreshCart().then((cart) => {
        if (cart) syncCartPricingUI(cart);
      });
    }

    return updated;
  }

  function refreshCartFromResponse(data, options) {
    options = options || {};
    if (data && (data.sections || typeof data.item_count === 'number' || data.id || data.items)) {
      invalidateCartJsCache();
    }
    const shouldOpenDrawer = options.openDrawer === true;
    const trigger = options.trigger || null;
    const cartPageUpdated = data && data.sections && refreshCartPageFromSections(data.sections);
    const drawer = getCartDrawer();

    const hasAddedItem = Boolean(
      data &&
        (data.id ||
          data.variant_id ||
          data.key ||
          (Array.isArray(data.items) && data.items.length > 0) ||
          (typeof data.item_count === 'number' && data.item_count > 0))
    );

    // If an item was confirmed added, immediately clear is-empty from drawer
    // so empty state is never flashed while rendering completes.
    if (drawer && hasAddedItem) {
      drawer.classList.remove('is-empty');
    }

    function maybeOpenDrawer() {
      if (!shouldOpenDrawer || !drawer || typeof drawer.open !== 'function') return;
      if (document.getElementById('VrvCartPage')) return;
      const wishlistDrawer = document.getElementById('wishlist-drawer');
      if (wishlistDrawer && wishlistDrawer.classList.contains('active')) {
        wishlistDrawer.classList.remove('active');
        wishlistDrawer.setAttribute('aria-hidden', 'true');
        const overlay = document.getElementById('wishlist-overlay');
        overlay?.classList.remove('active');
        overlay?.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
      }
      if (window.vrvSpinWheel && !window.vrvSpinWheel.hasPlayed()) {
        var didOpen = window.vrvSpinWheel.open();
        if (didOpen) return;
      }
      drawer._vrvLastRefreshAt = Date.now();
      beginDrawerSettle(drawer);
      drawer.open(trigger, { skipRefresh: true });
    }

    function afterRefresh() {
      updateCartIconBubble(data);
      if (drawer) {
        hideDismissedDiscountCards(drawer);
        enableDrawerCheckoutButton();
        bindExtras(drawer);
      }
      if (cartPageUpdated) bindExtras(document.getElementById('VrvCartPage') || document);
      maybeOpenDrawer();
    }

    if (!drawer) {
      if (cartPageUpdated) bindExtras(document.getElementById('VrvCartPage') || document);
      updateCartIconBubble(data);
      return Promise.resolve();
    }

    const wasEmptyBeforeSync = drawer.classList.contains('is-empty');
    const becomingEmpty = !wasEmptyBeforeSync && cartDataIsEmpty(data) && !hasAddedItem;

    if (becomingEmpty) {
      drawer.classList.add('is-empty');
      drawer.classList.remove('is-coupons-open');
      const couponsPage = document.getElementById('CartDrawer-CouponsPage');
      if (couponsPage) {
        couponsPage.classList.remove('is-open');
        couponsPage.setAttribute('hidden', '');
        couponsPage.setAttribute('aria-hidden', 'true');
      }
      updateCartIconBubble(data);
    }

    if (data && data.sections) {
      try {
        const drawerSectionHtml = data.sections['cart-drawer'];
        if (drawerSectionHtml) {
          const doc = new DOMParser().parseFromString(drawerSectionHtml, 'text/html');
          const hasLineItems = Boolean(
            doc.querySelector('.vrv-drawer__items .vrv-cart-line') ||
              doc.querySelector('.vrv-drawer__items [role="list"] > *')
          );

          if (hasLineItems || hasAddedItem) {
            drawer.classList.remove('is-empty');
            if (typeof drawer.renderContents === 'function') {
              drawer.renderContents(data);
              afterRefresh();
              return Promise.resolve();
            }
          }
        }

        if (typeof drawer.syncEmptyState === 'function') {
          drawer.syncEmptyState(data);
        }

        const partialResult = partialRefreshFromSections(data.sections);
        if (partialResult && typeof partialResult.then === 'function') {
          return partialResult.then(afterRefresh);
        }
        if (partialResult) {
          afterRefresh();
          return Promise.resolve();
        }

        if (typeof drawer.refreshDrawer === 'function') {
          return drawer.refreshDrawer(true).then(afterRefresh);
        }

        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          afterRefresh();
          return Promise.resolve();
        }
      } catch (e) {
        console.warn('refreshCartFromResponse failed', e);
      }
    }

    if (typeof drawer.refreshDrawer === 'function') {
      return drawer.refreshDrawer(true).then(afterRefresh);
    }

    afterRefresh();
    return Promise.resolve();
  }

  /**
   * After Add to Cart the drawer is first painted from the add response and then
   * re-rendered by follow-up syncs (pricing, gift wrap, coupons), which showed as
   * a flicker. Keep the contents hidden behind the slide-in until renders have
   * been quiet for a moment (hard cap 1.2s), so the shopper sees it once.
   */
  function beginDrawerSettle(drawer) {
    if (!drawer || drawer.classList.contains('active')) return;
    if (drawer._vrvSettleCleanup) drawer._vrvSettleCleanup();

    let quietTimer = null;
    let hardTimer = null;
    const finish = () => {
      clearTimeout(quietTimer);
      clearTimeout(hardTimer);
      document.removeEventListener('cart:updated', bump);
      drawer.classList.remove('vrv-is-settling');
      drawer._vrvSettleCleanup = null;
    };
    const bump = () => {
      clearTimeout(quietTimer);
      quietTimer = setTimeout(finish, 380);
    };

    drawer.classList.add('vrv-is-settling');
    drawer._vrvSettleCleanup = finish;
    document.addEventListener('cart:updated', bump);
    bump();
    hardTimer = setTimeout(finish, 1200);
  }

  window.vrvRefreshCartFromAdd = function (data, options) {
    const drawer = getCartDrawer();
    if (drawer && typeof drawer.clearPrefetchCache === 'function') {
      drawer.clearPrefetchCache();
    }
    const opts = Object.assign({ openDrawer: !document.getElementById('VrvCartPage'), trigger: options && options.trigger }, options || {});
    return Promise.resolve(window.vrvBeforeCartRender ? window.vrvBeforeCartRender(data) : data)
      .then(finalData => refreshCartFromResponse(finalData, opts))
      .catch((err) => {
        console.warn('[VRV] Cart refresh failed, retrying fallback', err);
        return refreshCartFromResponse(data, opts);
      });
  };

  function ensureDrawerCheckoutBar() {
    const drawer = getCartDrawer();
    const bar = document.getElementById('CartDrawer-CheckoutBar');
    if (!drawer || drawer.classList.contains('is-empty')) {
      if (bar) bar.hidden = true;
      return false;
    }
    if (bar) {
      bar.hidden = false;
      bar.removeAttribute('hidden');
      bar.style.removeProperty('display');
    }
    const btn = document.getElementById('CartDrawer-Checkout');
    if (btn) {
      btn.style.removeProperty('display');
      btn.style.removeProperty('visibility');
    }
    return true;
  }

  function enableDrawerCheckoutButton() {
    const btn = document.getElementById('CartDrawer-Checkout');
    const drawer = getCartDrawer();
    if (drawer && drawer.classList.contains('is-empty')) {
      ensureDrawerCheckoutBar();
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
      return false;
    }
    ensureDrawerCheckoutBar();
    if (!btn) return false;
    btn.disabled = false;
    btn.removeAttribute('disabled');
    btn.removeAttribute('aria-disabled');
    return true;
  }

  window.vrvEnsureDrawerCheckoutBar = ensureDrawerCheckoutBar;

  const VRV_BUY_NOW_SAVE_KEY = 'vrv_buy_now_saved_cart_v1';
  const VRV_BUY_NOW_ACTIVE_KEY = 'vrv_buy_now_active';
  const VRV_BUY_NOW_CHECKOUT_KEY = 'vrv_buy_now_checkout_started';
  const VRV_BUY_NOW_CART_READY_KEY = 'vrv_buy_now_cart_ready';
  // Same saved cart mirrored in localStorage so it survives the tab being closed
  // (e.g. shopper leaves for a UPI app and the browser drops the tab).
  const VRV_BUY_NOW_BACKUP_KEY = 'vrv_buy_now_backup_v1';
  const VRV_BUY_NOW_TAB_KEY = 'vrv_buy_now_tab_id';
  // Another tab may only take over a saved cart once its owner has been silent this long.
  const BUY_NOW_ADOPT_AFTER_MS = 2 * 60 * 1000;
  const BUY_NOW_SAVED_MAX_AGE_MS = 24 * 60 * 60 * 1000;

  // In-memory flag: only true when Buy Now was explicitly started on THIS page load.
  // sessionStorage persists across same-tab refreshes, so stale keys can survive even
  // after the user navigates back. This flag is the authoritative gate — it resets to
  // false on every page load and is only set to true by vrvMarkBuyNowCheckoutActive().
  let _vrvBuyNowActiveThisLoad = false;

  // Wipe the session-storage active flag on every page load. ACTIVE_KEY is only
  // meaningful while Razorpay is open on THIS page interaction; a stale value from
  // a previous use must never trigger a restore after page refresh.
  try { sessionStorage.removeItem(VRV_BUY_NOW_ACTIVE_KEY); } catch (_) {}

  function isBuyNowCheckoutActive() {
    return sessionStorage.getItem(VRV_BUY_NOW_ACTIVE_KEY) === '1';
  }

  function isBuyNowCartReady() {
    return sessionStorage.getItem(VRV_BUY_NOW_CART_READY_KEY) === '1';
  }

  function markBuyNowCartReady() {
    sessionStorage.setItem(VRV_BUY_NOW_CART_READY_KEY, '1');
  }

  function clearBuyNowCartReady() {
    sessionStorage.removeItem(VRV_BUY_NOW_CART_READY_KEY);
  }

  function clearStaleBuyNowForDrawerCheckout() {
    if (!isBuyNowCheckoutActive()) return;
    sessionStorage.removeItem(VRV_BUY_NOW_ACTIVE_KEY);
    sessionStorage.removeItem(VRV_BUY_NOW_CHECKOUT_KEY);
    clearBuyNowCartReady();
    if (typeof window.vrvUseNativeFetchForBuyNow === 'function') {
      window.vrvUseNativeFetchForBuyNow(false);
    }
  }

  window.vrvClearStaleBuyNowForDrawerCheckout = clearStaleBuyNowForDrawerCheckout;

  function cartAddLooksSuccessful(addResponse) {
    if (!addResponse || typeof addResponse !== 'object') return false;
    if (Number(addResponse.status) >= 400) return false;
    if (addResponse.id || addResponse.variant_id || addResponse.key) return true;
    return Array.isArray(addResponse.items) && addResponse.items.length > 0;
  }

  function readBuyNowSnapshot() {
    try {
      const raw = sessionStorage.getItem(VRV_BUY_NOW_SAVE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  }

  function clearBuyNowSessionKeys() {
    _vrvBuyNowActiveThisLoad = false;
    sessionStorage.removeItem(VRV_BUY_NOW_ACTIVE_KEY);
    sessionStorage.removeItem(VRV_BUY_NOW_SAVE_KEY);
    try { localStorage.removeItem(VRV_BUY_NOW_BACKUP_KEY); } catch (_) {}
    sessionStorage.removeItem(VRV_BUY_NOW_CHECKOUT_KEY);
    clearBuyNowCartReady();
    if (typeof window.vrvUseNativeFetchForBuyNow === 'function') {
      window.vrvUseNativeFetchForBuyNow(false);
    }
  }

  // ─── Buy Now: the shopper's real cart must never be lost ────────────────────
  //
  // Razorpay Magic Checkout can only check out the live Shopify cart, so Buy Now
  // temporarily swaps that cart for the single Buy Now product:
  //   1. save the real cart (sessionStorage, this tab only)
  //   2. clear the cart, add the Buy Now product, open checkout
  //   3. when the shopper comes back -- popup closed, browser Back, refresh, or
  //      any later page load in this tab -- put the saved lines back ON TOP of
  //      whatever is in the cart now (the Buy Now product stays).
  //
  // Restoring is "make sure the cart holds at least the saved quantity of each
  // saved line", never "add the saved quantity again". That makes it idempotent:
  // running it twice, or racing with the cross-device cart sync, cannot
  // duplicate items, and the same product is merged into one line (Shopify's
  // own quantity/stock rules still apply). The saved copy is only deleted once
  // every line is back (or was refused by stock/availability), so a network
  // failure can be retried instead of silently losing the cart.

  let _vrvBuyNowRestoreInFlight = null;
  let _vrvBuyNowStartInFlight = null;
  let _vrvBuyNowHasGiftWrap = false;
  // When Razorpay was asked to open (0 = not launched). Lets the watcher treat
  // "launched but never visible" (e.g. opened in another window) as closed.
  let _vrvBuyNowLaunchedAt = 0;

  function getBuyNowTabId() {
    try {
      let id = sessionStorage.getItem(VRV_BUY_NOW_TAB_KEY);
      if (!id) {
        id = Date.now().toString(36) + Math.random().toString(36).slice(2);
        sessionStorage.setItem(VRV_BUY_NOW_TAB_KEY, id);
      }
      return id;
    } catch (_) {
      return '';
    }
  }

  /** Save the real cart for this tab, plus a localStorage mirror. Throws if the tab copy can't be written. */
  function writeBuyNowSnapshot(snapshot) {
    sessionStorage.setItem(VRV_BUY_NOW_SAVE_KEY, JSON.stringify(snapshot));
    try {
      localStorage.setItem(
        VRV_BUY_NOW_BACKUP_KEY,
        JSON.stringify({ snapshot: snapshot, owner: getBuyNowTabId(), heartbeat: Date.now() })
      );
    } catch (_) {
      /* mirror is best-effort */
    }
  }

  function removeBuyNowSnapshot() {
    sessionStorage.removeItem(VRV_BUY_NOW_SAVE_KEY);
    try {
      localStorage.removeItem(VRV_BUY_NOW_BACKUP_KEY);
    } catch (_) {
      /* ignore */
    }
  }

  /** The owning tab proves it is alive so no other tab takes its saved cart over. */
  function touchBuyNowBackup() {
    try {
      const raw = localStorage.getItem(VRV_BUY_NOW_BACKUP_KEY);
      if (!raw) return;
      const backup = JSON.parse(raw);
      if (!backup || backup.owner !== getBuyNowTabId()) return;
      backup.heartbeat = Date.now();
      localStorage.setItem(VRV_BUY_NOW_BACKUP_KEY, JSON.stringify(backup));
    } catch (_) {
      /* ignore */
    }
  }

  /**
   * This tab has no saved cart, but the mirror does: the tab that made the swap
   * is gone (closed / killed by the OS). Take the saved cart over so the
   * shopper's items still come back. A tab that is still alive keeps refreshing
   * its heartbeat, so a live checkout in another tab is never disturbed.
   */
  function adoptOrphanedBuyNowSnapshot() {
    if (readBuyNowSnapshot()) return;
    try {
      const raw = localStorage.getItem(VRV_BUY_NOW_BACKUP_KEY);
      if (!raw) return;
      const backup = JSON.parse(raw);
      const snapshot = backup && backup.snapshot;
      if (!snapshot || typeof snapshot !== 'object') {
        localStorage.removeItem(VRV_BUY_NOW_BACKUP_KEY);
        return;
      }
      if (Date.now() - (Number(snapshot.startedAt) || 0) > BUY_NOW_SAVED_MAX_AGE_MS) {
        localStorage.removeItem(VRV_BUY_NOW_BACKUP_KEY);
        return;
      }
      if (Date.now() - (Number(backup.heartbeat) || 0) < BUY_NOW_ADOPT_AFTER_MS) return;
      sessionStorage.setItem(VRV_BUY_NOW_SAVE_KEY, JSON.stringify(snapshot));
    } catch (_) {
      /* ignore */
    }
  }

  function buyNowLineIdentity(id, properties) {
    const props = properties && typeof properties === 'object' ? properties : {};
    const keys = Object.keys(props)
      .filter((key) => props[key] != null && String(props[key]) !== '')
      .sort();
    return String(Number(id)) + '|' + keys.map((key) => key + '=' + props[key]).join('&');
  }

  function isBuyNowGiftWrapRow(row) {
    return Boolean(row && row.properties && row.properties.VrvGiftWrap != null);
  }

  function buyNowRowToAddItem(row, quantity) {
    const item = { id: Number(row.id), quantity: quantity };
    if (row.properties && typeof row.properties === 'object' && Object.keys(row.properties).length) {
      item.properties = row.properties;
    }
    return item;
  }

  function postBuyNowRestoreAdd(items) {
    return vrvFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then((response) => ({ ok: response.ok, status: response.status }));
  }

  /** Add one saved line back, settling for less if stock no longer allows the full quantity. */
  function restoreBuyNowLine(row) {
    const wanted = row.quantity;
    const tries = [wanted, wanted - 1, Math.ceil(wanted / 2), 1]
      .filter((qty, index, all) => qty >= 1 && all.indexOf(qty) === index)
      .sort((a, b) => b - a);
    let index = 0;

    function attempt() {
      if (index >= tries.length) return Promise.resolve({ transient: false, limited: true });
      const qty = tries[index++];
      return postBuyNowRestoreAdd([buyNowRowToAddItem(row, qty)]).then((result) => {
        if (result.ok) return { transient: false, limited: qty < wanted };
        // 422 = stock/availability refusal: a smaller quantity may still fit.
        if (result.status === 422) return attempt();
        // Other 4xx (e.g. variant deleted): retrying can't help, drop it.
        if (result.status >= 400 && result.status < 500 && result.status !== 429) {
          return { transient: false, limited: true };
        }
        return { transient: true, limited: false };
      });
    }

    return attempt().catch(() => ({ transient: true, limited: false }));
  }

  /**
   * Ensure the live cart holds at least the saved quantity of every saved line.
   * Resolves { remaining: rows to retry later, limited: something was refused }.
   */
  function ensureSnapshotLinesInCart(snapshot) {
    let tempLinesWereInCart = false;
    const baseRows = (snapshot.items || [])
      .map((row) => ({
        id: Number(row.id),
        quantity: Math.max(1, parseInt(row.quantity, 10) || 1),
        properties: row.properties,
      }))
      .filter((row) => row.id > 0);

    const dropTempLines = () =>
      fetchCartRaw({ bustCache: true }).then((cart) => {
        const tempKeys = Array.isArray(snapshot.tempKeys) ? snapshot.tempKeys : [];
        if (!tempKeys.length || !cart || !Array.isArray(cart.items)) return cart;
        const updates = {};
        cart.items.forEach((line) => {
          if (line && tempKeys.indexOf(line.key) !== -1) updates[line.key] = 0;
        });
        if (!Object.keys(updates).length) return cart;
        tempLinesWereInCart = true;
        return vrvFetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        })
          .then(() => {
            invalidateCartJsCache();
            return fetchCartRaw({ bustCache: true });
          })
          .catch(() => cart);
      });

    return dropTempLines().then((cart) => {
      if (!cart || !Array.isArray(cart.items)) throw new Error('Cart unavailable');

      // The Buy Now product is still in the temporary cart, i.e. checkout was
      // abandoned (not completed): keep it in the bag, merged into the saved
      // lines, rather than silently dropping the product the shopper picked.
      // After a completed order the temporary lines are gone, so nothing is re-added.
      const wantedRows = baseRows.slice();
      if (tempLinesWereInCart && Array.isArray(snapshot.tempItems)) {
        snapshot.tempItems.forEach((item) => {
          const identity = buyNowLineIdentity(item.id, item.properties);
          const match = wantedRows.find((row) => buyNowLineIdentity(row.id, row.properties) === identity);
          if (match) {
            match.quantity = Math.min(99, match.quantity + item.quantity);
          } else if (item.id > 0) {
            wantedRows.push({ id: item.id, quantity: item.quantity, properties: item.properties });
          }
        });
      }

      const have = new Map();
      cart.items.forEach((line) => {
        const key = buyNowLineIdentity(line.variant_id, line.properties);
        have.set(key, (have.get(key) || 0) + (Number(line.quantity) || 0));
      });

      // Real products first, gift-wrap lines last (they depend on a parent line).
      const missing = wantedRows
        .map((row) => ({
          row: row,
          need: row.quantity - (have.get(buyNowLineIdentity(row.id, row.properties)) || 0),
        }))
        .filter((entry) => entry.need > 0)
        .sort((a, b) => Number(isBuyNowGiftWrapRow(a.row)) - Number(isBuyNowGiftWrapRow(b.row)));

      if (!missing.length) return { remaining: [], limited: false };

      const asRow = (entry) => Object.assign({}, entry.row, { quantity: entry.need });
      return postBuyNowRestoreAdd(missing.map((entry) => buyNowRowToAddItem(entry.row, entry.need))).then((batch) => {
        if (batch.ok) return { remaining: [], limited: false };

        // The batch is all-or-nothing: retry line by line so one refused line
        // (stock, removed variant) can't keep the rest of the cart from coming back.
        const remaining = [];
        let limited = false;
        return missing
          .reduce(
            (chain, entry) =>
              chain.then(() =>
                restoreBuyNowLine(asRow(entry)).then((outcome) => {
                  if (outcome.transient) remaining.push(entry.row);
                  if (outcome.limited) limited = true;
                })
              ),
            Promise.resolve()
          )
          .then(() => ({ remaining: remaining, limited: limited }));
      });
    });
  }

  function refreshUiAfterBuyNowRestore(cart) {
    invalidateCartJsCache();
    if (!cart) return Promise.resolve();
    updateCartIconBubble(cart);
    return syncCartDrawerFromServer({ cart: cart }).then(() => {
      try {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: Object.assign({}, cart, { source: 'buy-now-restore' }) })
        );
      } catch (_) {
        /* ignore */
      }
    });
  }

  /** Remember the shopper's real cart before a temporary Buy Now checkout swap. */
  window.vrvSaveCartSnapshotForBuyNow = function () {
    // A previous Buy Now that was never restored must be settled first;
    // overwriting its saved copy with the temporary cart would lose the real one.
    const settled = readBuyNowSnapshot() ? window.vrvRestoreCartSnapshotAfterBuyNow() : Promise.resolve(true);

    return settled
      .then(() => {
        if (readBuyNowSnapshot()) {
          throw new Error('Your bag is still being restored. Please try again in a moment.');
        }
        // Always read the real cart: the shared 1.2s cache can be stale, and a
        // failed read must abort Buy Now rather than "save" an empty cart.
        return fetchCartRaw({ bustCache: true });
      })
      .then((cart) => {
        if (!cart || !Array.isArray(cart.items)) {
          throw new Error(
            'We could not read your bag, so Buy Now was cancelled to keep your items safe. Please try again.'
          );
        }
        const items = cart.items;
        const snapshot = {
          item_count: typeof cart.item_count === 'number' ? cart.item_count : items.length,
          items: items.map((item) => ({
            id: item.variant_id,
            quantity: item.quantity,
            properties:
              item.properties && typeof item.properties === 'object' && Object.keys(item.properties).length
                ? item.properties
                : undefined,
          })),
          startedAt: Date.now(),
          attempts: 0,
        };
        try {
          writeBuyNowSnapshot(snapshot);
        } catch (_) {
          throw new Error('Buy Now is unavailable in this browser mode. Please add the item to your bag instead.');
        }
        return snapshot;
      });
  };

  /**
   * Put the saved cart back after Buy Now popup close / checkout abandon / Back.
   * Safe to call any number of times; concurrent calls share one run.
   */
  window.vrvRestoreCartSnapshotAfterBuyNow = function (options) {
    if (_vrvBuyNowRestoreInFlight) return _vrvBuyNowRestoreInFlight;

    _vrvBuyNowActiveThisLoad = false;
    _vrvBuyNowLaunchedAt = 0;
    sessionStorage.removeItem(VRV_BUY_NOW_ACTIVE_KEY);
    sessionStorage.removeItem(VRV_BUY_NOW_CHECKOUT_KEY);
    clearBuyNowCartReady();
    if (typeof window.vrvUseNativeFetchForBuyNow === 'function') {
      window.vrvUseNativeFetchForBuyNow(false);
    }

    adoptOrphanedBuyNowSnapshot();
    const snapshot = readBuyNowSnapshot();
    if (!snapshot) return Promise.resolve(false);

    // Keep the saved copy (minus what is already back) so a failed attempt is
    // retried on the next page load. Only a day-old copy is given up on: the
    // shopper's items are worth more than an occasional extra retry.
    const keepForRetry = (items) => {
      try {
        if (Date.now() - (Number(snapshot.startedAt) || Date.now()) > BUY_NOW_SAVED_MAX_AGE_MS) {
          removeBuyNowSnapshot();
        } else {
          writeBuyNowSnapshot(
            Object.assign({}, snapshot, { items: items, attempts: (Number(snapshot.attempts) || 0) + 1 })
          );
        }
      } catch (_) {
        /* ignore */
      }
    };

    let job;
    if ((!snapshot.items || !snapshot.items.length) && Array.isArray(snapshot.tempItems) && snapshot.tempItems.length) {
      // Cart was empty before Buy Now. If the Buy Now product is still in the
      // temporary cart (checkout abandoned / Back), leave it there so the
      // product the shopper chose is in their bag. After a completed order the
      // cart is already empty and this is a no-op.
      job = Promise.resolve().then(() => {
        removeBuyNowSnapshot();
        return { limited: false };
      });
    } else if (!snapshot.items || !snapshot.items.length) {
      // The cart was empty before Buy Now: leave it empty again.
      job = vrvFetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      }).then((response) => {
        if (!response.ok) throw new Error('Could not clear cart');
        removeBuyNowSnapshot();
        return { limited: false };
      });
    } else {
      job = ensureSnapshotLinesInCart(snapshot).then((result) => {
        if (result.remaining.length) keepForRetry(result.remaining);
        else removeBuyNowSnapshot();
        return result;
      });
    }

    _vrvBuyNowRestoreInFlight = job
      .then((result) =>
        fetchCartRaw({ bustCache: true }).then((cart) =>
          refreshUiAfterBuyNowRestore(cart).then(() => {
            if (result && result.limited && window.vrvCartAddHelpers && window.vrvCartAddHelpers.showCartMessage) {
              window.vrvCartAddHelpers.showCartMessage(
                'Some items in your bag were limited by available stock when it was restored.'
              );
            }
            // The cart page is server-rendered; re-render it from the real cart.
            // (Only once nothing is left to retry, so a flaky network can't cause a reload loop.)
            if (document.getElementById('VrvCartPage') && !readBuyNowSnapshot()) {
              window.location.reload();
            }
            return true;
          })
        )
      )
      .catch((err) => {
        console.warn('Restore cart after Buy Now failed', err);
        if (readBuyNowSnapshot()) keepForRetry(snapshot.items);
        return false;
      })
      .finally(() => {
        _vrvBuyNowRestoreInFlight = null;
      });

    return _vrvBuyNowRestoreInFlight;
  };

  window.vrvMarkBuyNowCheckoutActive = function () {
    _vrvBuyNowActiveThisLoad = true;
    sessionStorage.setItem(VRV_BUY_NOW_ACTIVE_KEY, '1');
  };

  window.vrvCommitBuyNowCheckoutNavigation = function () {
    sessionStorage.removeItem(VRV_BUY_NOW_ACTIVE_KEY);
    sessionStorage.setItem(VRV_BUY_NOW_CHECKOUT_KEY, '1');
  };

  /**
   * Runs on every page load / pageshow (including bfcache restores after Back).
   * A saved cart in this tab means Buy Now left the real cart swapped out.
   */
  window.vrvMaybeRestoreCartAfterBuyNowReturn = function (options) {
    const path = (window.location && window.location.pathname) || '';
    if (path.indexOf('/checkouts') === 0 || path === '/checkout' || path === '/checkout/') {
      return Promise.resolve(false);
    }
    // Restored from the back/forward cache: the shopper navigated away from the
    // checkout and is back, so whatever this page thought was "in progress" is over.
    if (options && options.fromHistory) {
      _vrvBuyNowActiveThisLoad = false;
      _vrvBuyNowLaunchedAt = 0;
      sessionStorage.removeItem(VRV_BUY_NOW_ACTIVE_KEY);
    }
    adoptOrphanedBuyNowSnapshot();
    if (!readBuyNowSnapshot()) {
      // Stale flags with nothing to restore.
      if (sessionStorage.getItem(VRV_BUY_NOW_CHECKOUT_KEY) === '1') clearBuyNowSessionKeys();
      return Promise.resolve(false);
    }
    // Buy Now is being started on this very page; it restores itself.
    if (_vrvBuyNowActiveThisLoad && isBuyNowCheckoutActive()) return Promise.resolve(false);
    return window.vrvRestoreCartSnapshotAfterBuyNow();
  };

  function waitForMagicBuyNow(maxMs) {
    if (typeof window.onBuyNowClickMagic === 'function') {
      return Promise.resolve();
    }
    const deadline = Date.now() + (maxMs || 12000);
    return new Promise((resolve, reject) => {
      const poll = setInterval(() => {
        if (typeof window.onBuyNowClickMagic === 'function') {
          clearInterval(poll);
          resolve();
          return;
        }
        if (Date.now() > deadline) {
          clearInterval(poll);
          reject(new Error('Buy Now checkout is still loading. Please refresh and try again.'));
        }
      }, 100);
    });
  }

  function getGiftWrapHelpers() {
    return window.vrvGiftWrapHelpers || {};
  }

  function getGiftWrapDiscountRestore(cart) {
    const helpers = getGiftWrapHelpers();
    if (typeof helpers.getGiftWrapDiscountRestoreCents !== 'function') return 0;
    return helpers.getGiftWrapDiscountRestoreCents(cart);
  }

  function getCheckoutOrderCouponsList() {
    const raw = (window.vrvGiftWrapConfig && window.vrvGiftWrapConfig.checkoutOrderCoupons) || '';
    return String(raw)
      .split(',')
      .map((code) => normalizeDiscountCode(code.trim()))
      .filter(Boolean);
  }

  function getCheckoutMirrorCoupon() {
    return normalizeDiscountCode(
      (window.vrvGiftWrapConfig && window.vrvGiftWrapConfig.checkoutMirrorCoupon) || ''
    );
  }

  /** When gift wrap is in cart, swap order-wide storefront codes (e.g. NEW30) to jewellery-only mirror. */
  function mapCouponForGiftWrapCart(code, cart) {
    const normalized = normalizeDiscountCode(code);
    if (!normalized || !cart || !findGiftWrapCartLine(cart)) return normalized;

    const mirror = getCheckoutMirrorCoupon();
    if (!mirror || mirror === normalized) return normalized;

    if (getCheckoutOrderCouponsList().includes(normalized)) return mirror;
    return normalized;
  }

  function cartDiscountCodeChanged(before, after) {
    const oldCode = normalizeDiscountCode(resolveActiveCartDiscountCode(before));
    const newCode = normalizeDiscountCode(resolveActiveCartDiscountCode(after));
    return Boolean(oldCode && newCode && oldCode !== newCode);
  }

  function wrapFetchWithGiftWrapPatch(baseFetch) {
    const helpers = getGiftWrapHelpers();
    if (typeof helpers.wrapFetchForGiftWrapCartPatch === 'function') {
      return helpers.wrapFetchForGiftWrapCartPatch(baseFetch);
    }
    return baseFetch;
  }

  function resolveBuyNowAutoCouponCode() {
    try {
      const preferred = (window.sessionStorage.getItem('vrvPreferredCoupon') || '').trim();
      if (preferred) return preferred;
    } catch (_) {}

    const card = document.querySelector('[data-vrv-auto-apply="1"]');
    if (card) {
      const code = card.getAttribute('data-vrv-offer-code');
      if (code) return String(code).trim();
    }

    const autoSpan = document.querySelector('[data-vrv-auto-apply-code]');
    if (autoSpan) {
      const code = autoSpan.getAttribute('data-vrv-auto-apply-code');
      if (code) return String(code).trim();
    }

    if (window.vrvAutoApplyCoupon && window.vrvAutoApplyCoupon.code) {
      return String(window.vrvAutoApplyCoupon.code).trim();
    }

    return '';
  }

  function shouldApplyBuyNowCoupon(code) {
    const normalized = normalizeDiscountCode(code);
    if (!normalized) return false;
    if (isHiddenCode(normalized)) return false;
    if (getDismissedDiscounts().has(normalized)) return false;
    try {
      if (window.sessionStorage && window.sessionStorage.getItem('vrvAutoApplyBlocked:' + normalized) === '1') {
        return false;
      }
    } catch (_) {}
    return true;
  }

  function applyDiscountSilent(code) {
    const normalized = normalizeDiscountCode(code);
    if (!normalized) return Promise.resolve(null);

    return vrvFetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(buildCartUpdateBody({ discount: normalized })),
    })
      .then((r) => r.json().catch(() => null))
      .then((data) => {
        invalidateCartJsCache();
        return data;
      });
  }

  function applyDiscountSilentWithRetry(code, attemptsLeft) {
    const normalized = normalizeDiscountCode(code);
    const tries = Math.max(1, Number(attemptsLeft) || 3);

    function attempt(remaining) {
      return applyDiscountSilent(normalized).then((data) => {
        if (discountEffectivelyActive(data, normalized) || remaining <= 1) return data;
        return new Promise((resolve) => setTimeout(resolve, 350)).then(() => attempt(remaining - 1));
      });
    }

    return attempt(tries);
  }

  function addBuyNowCartLine(item) {
    return vrvFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: [item] }),
    }).then((r) =>
      r
        .json()
        .catch(() => ({}))
        .then((data) => ({
          ok: r.ok,
          data: data && typeof data === 'object' ? data : {},
        }))
    );
  }

  function changeCartLine(lineKey, quantity) {
    if (!lineKey) return Promise.resolve(null);
    return vrvFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: String(lineKey),
        quantity: Math.max(0, Number(quantity) || 0),
      }),
    })
      .then((r) => r.json().catch(() => null))
      .then((data) => {
        invalidateCartJsCache();
        return data;
      });
  }

  function findGiftWrapCartLine(cart) {
    const helpers = getGiftWrapHelpers();
    const isGiftWrap =
      typeof helpers.isGiftWrapCartItem === 'function' ? helpers.isGiftWrapCartItem : () => false;
    return (cart && cart.items ? cart.items : []).find(isGiftWrap) || null;
  }

  function resolveActiveCartDiscountCode(cart) {
    const codes = (cart && cart.discount_codes) || [];
    const applicable = codes.find((c) => c && c.code && c.applicable !== false);
    if (applicable && applicable.code) return String(applicable.code).trim();
    return resolveBuyNowAutoCouponCode();
  }

  function shouldReapplyDiscountForGiftWrapRebuild(cart, code) {
    const normalized = normalizeDiscountCode(code);
    if (!normalized) return false;
    if (cartHasActiveDiscount(cart) || cartAlreadyHasDiscountCode(cart, normalized)) {
      return true;
    }
    return shouldApplyBuyNowCoupon(code);
  }

  function verifyGiftWrapNotDiscounted(cart) {
    return Boolean(cart) && getGiftWrapDiscountRestore(cart) <= 0;
  }

  /** Prefer jewellery-only mirror coupon (e.g. NEW30J) over order-wide codes like NEW30. */
  function resolveDiscountCodeForGiftWrapCheckout(cart) {
    const mirror = getCheckoutMirrorCoupon();
    const activeNorm = normalizeDiscountCode(resolveActiveCartDiscountCode(cart));
    if (mirror && getCheckoutOrderCouponsList().includes(activeNorm)) return mirror;
    if (mirror && mirror !== activeNorm) return mirror;
    return activeNorm;
  }

  function discountSwapSucceeded(before, after) {
    if (!after) return false;
    if (getGiftWrapDiscountRestore(after) <= 0) return true;
    if (cartDiscountCodeChanged(before, after)) return true;
    return checkoutDiscountSwapImproved(before, after);
  }

  function forceNuclearRebuildCartForGiftWrap(cart) {
    const gwItem = findGiftWrapCartLine(cart);
    if (!gwItem) return Promise.resolve(cart);

    const code = resolveDiscountCodeForGiftWrapCheckout(cart);
    const gwLine = {
      id: Number(gwItem.variant_id),
      quantity: Math.max(1, Number(gwItem.quantity) || 1),
      properties: Object.assign({ VrvGiftWrap: 'yes' }, gwItem.properties || {}),
    };

    const otherLines = (cart.items || [])
      .filter((item) => item.key !== gwItem.key)
      .map((item) => {
        const line = {
          id: Number(item.variant_id),
          quantity: Math.max(1, Number(item.quantity) || 1),
        };
        if (item.properties && typeof item.properties === 'object' && Object.keys(item.properties).length) {
          line.properties = item.properties;
        }
        return line;
      });

    return vrvFetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    })
      .then(() => invalidateCartJsCache())
      .then(() =>
        otherLines.reduce(
          (chain, line) =>
            chain.then(() =>
              addBuyNowCartLine(line).then(({ ok, data }) => {
                if (!cartAddLooksSuccessful(data) || !ok) {
                  throw new Error('Could not rebuild cart for checkout.');
                }
              })
            ),
          Promise.resolve()
        )
      )
      .then(() => {
        if (!code || !shouldReapplyDiscountForGiftWrapRebuild(cart, code)) return null;
        return applyDiscountSilent(code);
      })
      .then(() =>
        addBuyNowCartLine(gwLine).then(({ ok, data }) => {
          if (!cartAddLooksSuccessful(data) || !ok) {
            throw new Error('Could not add gift wrap for checkout.');
          }
        })
      )
      .then(() => fetchCartRaw())
      .then((fresh) => fresh || cart)
      .catch((err) => {
        // The cart was emptied before rebuilding. If any step failed, put back
        // whatever is missing instead of leaving the shopper with a partial cart.
        return ensureSnapshotLinesInCart({ items: otherLines.concat([gwLine]) })
          .catch(() => null)
          .then(() => {
            invalidateCartJsCache();
            throw err;
          });
      });
  }

  /**
   * Re-apply coupon on main lines only, then add gift wrap last (full ₹49).
   * Uses unpatched cart.js so we detect real Shopify discount on gift wrap.
   */
  function rebuildCartDiscountExcludingGiftWrap() {
    return fetchCartRaw().then((cart) => {
      const gwItem = findGiftWrapCartLine(cart);
      if (!gwItem || !gwItem.key) return cart;

      const gwRestore = getGiftWrapDiscountRestore(cart);
      const activeCode = resolveActiveCartDiscountCode(cart);

      // Gift Wrap is already full-price, so the cart is checkout-safe. Do not
      // remove/re-add it merely because another scoped discount (the combo)
      // exists: that changes the live cart immediately before Razorpay reads
      // it and makes Razorpay's earlier item snapshot look unavailable.
      if (gwRestore <= 0) return cart;

      const code = activeCode;
      const gwVariantId = gwItem.variant_id;
      const gwProps = Object.assign({ VrvGiftWrap: 'yes' }, gwItem.properties || {});
      const cartBefore = cart;

      return clearCartDiscountCodes()
        .catch(() => null)
        .then(() => changeCartLine(gwItem.key, 0))
        .then(() => {
          if (!code || !shouldReapplyDiscountForGiftWrapRebuild(cartBefore, code)) return fetchCartRaw();
          const applyCode =
            gwRestore > 0 ? resolveDiscountCodeForGiftWrapCheckout(cartBefore) : normalizeDiscountCode(code);
          return applyDiscountSilent(applyCode).then(() => fetchCartRaw());
        })
        .then(() =>
          addBuyNowCartLine({
            id: Number(gwVariantId),
            quantity: Math.max(1, Number(gwItem.quantity) || 1),
            properties: gwProps,
          })
        )
        .then(() => fetchCartRaw())
        .then((fresh) => {
          if (!fresh) return cartBefore;
          return fresh;
        });
    });
  }

  window.vrvRebuildCartDiscountExcludingGiftWrap = rebuildCartDiscountExcludingGiftWrap;

  function buildMainBuyNowLine(mainItem) {
    const line = {
      id: Number(mainItem.id),
      quantity: Math.max(1, parseInt(mainItem.quantity, 10) || 1),
    };
    if (mainItem.properties && typeof mainItem.properties === 'object') {
      line.properties = mainItem.properties;
    }
    return line;
  }

  /**
   * Buy Now cart: main + gift wrap in one add, then coupon, then discount rebuild.
   */
  function buildBuyNowCartWithGiftWrap(mainItem, giftVariantId) {
    const giftId = giftVariantId ? String(giftVariantId).trim() : '';
    const addLines =
      window.vrvGiftWrapCart && typeof window.vrvGiftWrapCart.addBuyNowLines === 'function'
        ? window.vrvGiftWrapCart.addBuyNowLines(mainItem, giftId)
        : addBuyNowCartLine(buildMainBuyNowLine(mainItem)).then(({ ok, data }) => {
            if (!cartAddLooksSuccessful(data) || !ok) {
              throw new Error('Could not add product for Buy Now checkout. Please try again.');
            }
            if (!giftId) return { ok: true, data };
            return addBuyNowCartLine({
              id: Number(giftId),
              quantity: 1,
              properties: { VrvGiftWrap: 'yes' },
            }).then(({ ok: gwOk, data: gwData }) => {
              if (!cartAddLooksSuccessful(gwData) || !gwOk) {
                throw new Error('Could not add gift wrap for Buy Now checkout. Please try again.');
              }
              return { ok: true, data: gwData };
            });
          });

    return addLines
      .then(() => fetchCartNow())
      .then((cart) => {
        const code = resolveBuyNowAutoCouponCode();
        if (!code || !shouldApplyBuyNowCoupon(code)) return cart;
        const applyCode = mapCouponForGiftWrapCart(code, cart) || code;
        if (cart && cartAlreadyHasDiscountCode(cart, applyCode)) return cart;
        if (cart && cartHasActiveDiscount(cart)) return cart;
        return applyDiscountSilent(applyCode).then(() => fetchCartNow());
      })
      .then((cart) => cart);
  }

  function addBuyNowCartLines(mainItem, giftVariantId) {
    if (giftVariantId) {
      return buildBuyNowCartWithGiftWrap(mainItem, giftVariantId).then((cart) => ({
        ok: Boolean(cart && Number(cart.item_count) > 0),
        data: cart && typeof cart === 'object' ? cart : {},
      }));
    }

    const items = [buildMainBuyNowLine(mainItem)];
    return vrvFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    }).then((r) =>
      r
        .json()
        .catch(() => ({}))
        .then((data) => ({
          ok: r.ok,
          data: data && typeof data === 'object' ? data : {},
        }))
    );
  }

  function waitForNonemptyCart(maxAttempts, delayMs) {
    const attempts = Math.max(1, maxAttempts || 12);
    const delay = Math.max(80, delayMs || 180);

    function attempt(left) {
      return fetchCartNow().then((cart) => {
        if (cart && Number(cart.item_count) > 0) return cart;
        if (left <= 1) {
          const err = new Error(
            'Could not prepare Buy Now checkout. Please try again.'
          );
          err.code = 'VRV_BUY_NOW_EMPTY_CART';
          throw err;
        }
        return new Promise((resolve) => setTimeout(resolve, delay)).then(() => attempt(left - 1));
      });
    }

    return attempt(attempts);
  }

  /** Save cart → empty cart (temp) for single-item Buy Now checkout. */
  window.vrvPrepareBuyNowCheckout = function () {
    clearBuyNowCartReady();
    window.vrvUseNativeFetchForBuyNow(true);
    return window
      .vrvSaveCartSnapshotForBuyNow()
      .then(() => window.vrvClearCartForBuyNow({ preserveBubble: true }))
      .then(() => {
        window.vrvMarkBuyNowCheckoutActive();
      })
      .catch((err) => {
        window.vrvUseNativeFetchForBuyNow(false);
        throw err;
      });
  };

  /**
   * The cart was emptied before the Buy Now product was added, so every line in
   * it right now is temporary. Remember their keys on the saved snapshot so the
   * restore can take them out again -- otherwise the Buy Now copy of a product
   * that was already in the bag stayed behind as a second, duplicate line.
   */
  function recordBuyNowTempLines() {
    return fetchCartRaw({ bustCache: true })
      .then((cart) => {
        const snap = readBuyNowSnapshot();
        if (!snap || !cart || !Array.isArray(cart.items)) return;
        writeBuyNowSnapshot(
          Object.assign({}, snap, {
            tempKeys: cart.items.map((line) => line && line.key).filter(Boolean),
            tempItems: cart.items
              .filter((line) => line && line.variant_id)
              .map((line) => ({
                id: Number(line.variant_id),
                quantity: Math.max(1, Number(line.quantity) || 1),
                properties:
                  line.properties && typeof line.properties === 'object' && Object.keys(line.properties).length
                    ? line.properties
                    : undefined,
              })),
          })
        );
      })
      .catch(() => {});
  }

  const BUY_NOW_STOCK_MESSAGE = "You can't add more than the available stock quantity.";

  function looksLikeStockError(text) {
    return /stock|available|only\s+\d+|all\s+\d+|inventory|cannot be added|can't be added|sold out/i.test(String(text || ''));
  }

  /**
   * Check requested quantity against tracked stock BEFORE touching the cart.
   * Without this the cart was emptied first and the add then failed (or
   * trimmed), which showed "1 item" and then "0".
   */
  function preflightBuyNowStock(mainItem) {
    const qty = Math.max(1, parseInt(mainItem.quantity, 10) || 1);
    const path = (window.location && window.location.pathname) || '';
    if (path.indexOf('/products/') === -1) return Promise.resolve();
    return fetch(path + '?view=vrv-stock&t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
      .then((data) => {
        const info = data && data.variants && data.variants[String(mainItem.id)];
        if (!info || !info.managed || info.policy === 'continue') return;
        const available = Math.max(0, Number(info.qty) || 0);
        if (qty > available) {
          const err = new Error(BUY_NOW_STOCK_MESSAGE);
          err.code = 'VRV_BUY_NOW_STOCK';
          throw err;
        }
      });
  }

  /**
   * PDP Buy Now — saves cart, then Razorpay magic (default) or custom add (gift wrap).
   */
  window.vrvStartBuyNowFromPdp = function (clickEvent, options) {
    const opts = options || {};
    const giftVariantId = opts.giftVariantId ? String(opts.giftVariantId).trim() : '';
    const mainItem = opts.mainItem;

    if (!mainItem || !mainItem.id) {
      return Promise.reject(new Error('Please select a product option before Buy Now.'));
    }

    // A second click while the first is still preparing must not start another swap.
    if (_vrvBuyNowStartInFlight) return _vrvBuyNowStartInFlight;
    _vrvBuyNowHasGiftWrap = Boolean(giftVariantId);

    clearBuyNowCartReady();
    window.vrvUseNativeFetchForBuyNow(true);
    watchMagicCheckoutCloseForBuyNow();

    _vrvBuyNowStartInFlight = preflightBuyNowStock(mainItem)
      .then(() => window.vrvSaveCartSnapshotForBuyNow())
      .then(() => {
        // Settling an earlier unrestored Buy Now re-enables the cart patches; turn them off again.
        window.vrvUseNativeFetchForBuyNow(true);
        const snap = readBuyNowSnapshot();
        if (snap && typeof snap.item_count === 'number') {
          updateCartIconBubble({ item_count: snap.item_count });
        }
        window.vrvMarkBuyNowCheckoutActive();
      })
      .then(() => {
        // Razorpay's product-level Buy Now endpoint is disabled for this shop
        // (`buyNowEnabled: false`) and opens a shell that subsequently fails
        // with "Getting Error from BuyNow". Build a temporary one-product
        // Shopify cart for every Buy Now click, then use the working cart Magic
        // Checkout endpoint. The original cart snapshot is restored when the
        // Razorpay popup closes or the shopper returns.
        return window
          .vrvClearCartForBuyNow({ preserveBubble: true })
          .then(() => addBuyNowCartLines(mainItem, giftVariantId))
          .then(({ ok, data }) => {
            if (!cartAddLooksSuccessful(data) || !ok) {
              const detail = data && (data.description || data.message);
              throw new Error(
                looksLikeStockError(detail)
                  ? BUY_NOW_STOCK_MESSAGE
                  : 'Could not add product for Buy Now checkout. Please try again.'
              );
            }
            invalidateCartJsCache();
            return recordBuyNowTempLines().then(() => {
              markBuyNowCartReady();
              return window.vrvProceedToCheckoutPreview(clickEvent, { cartReady: true });
            });
          });
      })
      .catch((err) => {
        console.warn('Buy Now failed', err);
        if (typeof window.vrvRestoreCartSnapshotAfterBuyNow === 'function') {
          return window.vrvRestoreCartSnapshotAfterBuyNow({ silent: true }).then(() => {
            throw err;
          });
        }
        clearBuyNowSessionKeys();
        throw err;
      })
      .finally(() => {
        _vrvBuyNowStartInFlight = null;
      });

    return _vrvBuyNowStartInFlight;
  };

  /** Empty cart temporarily for Buy Now (restored when popup closes). */
  window.vrvClearCartForBuyNow = function (options) {
    const opts = options || {};
    return vrvFetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((r) => {
        if (!r.ok) {
          return r
            .json()
            .catch(() => ({}))
            .then((body) => {
              const msg =
                (body && (body.description || body.message)) || 'Could not reset cart for Buy Now.';
              throw new Error(msg);
            });
        }
        return r.json().catch(() => ({}));
      })
      .then((cart) => {
        invalidateCartJsCache();
        const drawer = getCartDrawer();
        if (drawer) drawer.classList.add('is-empty');
        const btn = document.getElementById('CartDrawer-Checkout');
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
        if (!opts.preserveBubble) {
          updateCartIconBubble(cart && typeof cart.item_count === 'number' ? cart : { item_count: 0 });
        }
        return cart;
      });
  };

  /** Buy Now: enable checkout; keep header bubble showing the saved cart count. */
  window.vrvBuyNowAfterAdd = function (addResponse) {
    const snapshot = readBuyNowSnapshot();
    if (snapshot && typeof snapshot.item_count === 'number') {
      updateCartIconBubble({ item_count: snapshot.item_count });
    }
    enableDrawerCheckoutButton();
    invalidateCartJsCache();

    if (!cartAddLooksSuccessful(addResponse)) {
      return Promise.reject(
        new Error('Could not add this product for Buy Now checkout. Please try again.')
      );
    }

    markBuyNowCartReady();
    return syncCartDrawerFromServer().then(() => addResponse);
  };

  function withNativeFetch(run) {
    const native = window.__vrvNativeFetch;
    if (!native) return run();
    const saved = window.fetch;
    window.fetch = native;
    try {
      return run();
    } finally {
      window.fetch = saved;
    }
  }

  function installCheckoutGiftWrapFetchPatch() {
    disableGiftWrapCartPatchesForCheckout();
  }

  function restoreTrueFetchForCheckout() {
    disableGiftWrapCartPatchesForCheckout();
  }

  window.vrvInstallCheckoutGiftWrapFetchPatch = installCheckoutGiftWrapFetchPatch;
  window.vrvRestoreTrueFetchForCheckout = restoreTrueFetchForCheckout;

  window.vrvUseNativeFetchForBuyNow = function (enable) {
    if (enable) {
      disableGiftWrapCartPatchesForCheckout();
      return;
    }
    if (window.vrvSetGiftWrapCartPatchesEnabled) {
      window.vrvSetGiftWrapCartPatchesEnabled(true);
    } else {
      window.__vrvGiftWrapCartPatchesDisabled = false;
      if (window.__vrvPatchedFetch) {
        window.fetch = window.__vrvPatchedFetch;
      }
    }
  };

  function getOrderDiscountPercentFromCart(cart) {
    if (!cart) return 0;
    const apps = []
      .concat(cart.discount_applications || [], cart.cart_level_discount_applications || [])
      .filter(Boolean);
    for (const app of apps) {
      if (app.target_type === 'shipping_line') continue;
      if (app.value_type === 'percentage' && Number(app.value) > 0) return Number(app.value);
      if (app.value_type === 'percent' && Number(app.value) > 0) return Number(app.value);
    }
    return 0;
  }

  function calculateJewelryOnlyDiscountCents(cart) {
    const helpers = getGiftWrapHelpers();
    const isGW =
      typeof helpers.isGiftWrapCartItem === 'function' ? helpers.isGiftWrapCartItem : () => false;

    let lineSavings = 0;
    let jewelryOriginal = 0;
    (cart.items || []).forEach((item) => {
      if (isGW(item)) return;
      const orig = Number(item.original_line_price) || 0;
      const fin = Number(item.final_line_price) || 0;
      jewelryOriginal += orig;
      lineSavings += Math.max(0, orig - fin);
    });

    if (lineSavings > 0) return lineSavings;

    const percent = getOrderDiscountPercentFromCart(cart);
    if (percent > 0 && jewelryOriginal > 0) {
      return Math.round((jewelryOriginal * percent) / 100);
    }
    return 0;
  }

  function getVrvWorkerBaseUrl() {
    const cfg = window.vrvGiftWrapConfig || {};
    if (cfg.workerBaseUrl) return String(cfg.workerBaseUrl).replace(/\/+$/, '');
    const spin = (window.vrvUserSyncConfig && window.vrvUserSyncConfig.spinUrl) || '';
    if (spin) return spin.replace(/\/spin-event\/?$/i, '');
    return 'https://vervit-discount-sync.rishika-35d.workers.dev';
  }

  function checkoutDiscountSwapImproved(cart, fresh) {
    if (!cart || !fresh) return false;
    const beforeTotal = Number(cart.total_price) || 0;
    const afterTotal = Number(fresh.total_price) || 0;
    const gwRestoreBefore = getGiftWrapDiscountRestore(cart);
    const gwRestoreAfter = getGiftWrapDiscountRestore(fresh);
    if (gwRestoreBefore > 0 && gwRestoreAfter < gwRestoreBefore) return true;
    if (gwRestoreBefore > 0 && afterTotal >= beforeTotal + gwRestoreBefore - 10) return true;
    return false;
  }

  /**
   * Only swap when gift wrap is actually discounted on the real Shopify cart.
   * NEW30 is collection-scoped (17 collections) — if gift wrap is not in those
   * collections, no swap is needed. Worker codes must never be entire-order.
   */
  function swapOrderDiscountToJewelryFixedAmount(cart) {
    const jewelryCents = calculateJewelryOnlyDiscountCents(cart);
    const gwRestore = getGiftWrapDiscountRestore(cart);
    if (jewelryCents <= 0 || gwRestore <= 0) return Promise.resolve(cart);

    const oldCode = resolveActiveCartDiscountCode(cart);
    if (oldCode && String(oldCode).toUpperCase().startsWith('VRVGW')) {
      let restoreCode = getCheckoutMirrorCoupon();
      if (!restoreCode) {
        try {
          const preferred = normalizeDiscountCode(window.sessionStorage.getItem('vrvPreferredCoupon') || '');
          if (preferred && !preferred.startsWith('VRVGW')) restoreCode = preferred;
        } catch (_) {}
      }
      return clearCartDiscountCodes()
        .catch(() => null)
        .then(() => (restoreCode ? applyDiscountSilentWithRetry(restoreCode) : null))
        .then(() => fetchCartRaw());
    }

    const mirror = getCheckoutMirrorCoupon();

    function tryMirrorSwap() {
      if (!mirror || mirror === normalizeDiscountCode(oldCode)) {
        return fetchCartRaw().then((fresh) => fresh || cart);
      }
      return clearCartDiscountCodes()
        .catch(() => null)
        .then(() => applyDiscountSilentWithRetry(mirror))
        .then(() => fetchCartRaw())
        .then((fresh) => (discountSwapSucceeded(cart, fresh) ? fresh : cart));
    }

    if (mirror && mirror !== normalizeDiscountCode(oldCode)) {
      return tryMirrorSwap().then((mirrored) => {
        if (mirrored && verifyGiftWrapNotDiscounted(mirrored)) return mirrored;
        if (mirrored && cartDiscountCodeChanged(cart, mirrored)) return mirrored;
        return fetchWorkerSwap();
      });
    }

    return fetchWorkerSwap();

    function fetchWorkerSwap() {
      return fetch(getVrvWorkerBaseUrl() + '/gift-wrap-checkout-discount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({
          amount_cents: jewelryCents,
          currency: 'INR',
          replaces_code: oldCode || '',
        }),
      })
        .then((r) => (r.ok ? r.json() : null))
        .then((body) => {
          if (!body || !body.ok || !body.code) {
            console.warn('[VRV gift wrap] Worker checkout discount:', body && body.error, body && body.detail);
            return tryMirrorSwap();
          }
          return clearCartDiscountCodes()
            .catch(() => null)
            .then(() => applyDiscountSilentWithRetry(body.code))
            .then(() => fetchCartRaw())
            .then((fresh) => {
              if (discountSwapSucceeded(cart, fresh)) return fresh;
              return tryMirrorSwap();
            });
        })
        .catch(() => tryMirrorSwap());
    }
  }

  let _vrvGiftWrapIntegrityInFlight = null;

  function maintainGiftWrapDiscountIntegrity() {
    if (_vrvGiftWrapIntegrityInFlight) return _vrvGiftWrapIntegrityInFlight;

    const dependencyReady = typeof window.vrvEnsureGiftWrapDependencies === 'function'
      ? window.vrvEnsureGiftWrapDependencies()
      : Promise.resolve();
    _vrvGiftWrapIntegrityInFlight = dependencyReady
      .then(() => fetchCartRaw({ bustCache: true }))
      .catch(() => null)
      .finally(() => {
        _vrvGiftWrapIntegrityInFlight = null;
      });

    return _vrvGiftWrapIntegrityInFlight;
  }

  function scheduleGiftWrapDiscountIntegrity() {
    maintainGiftWrapDiscountIntegrity()
      .then((cart) => {
        if (cart) syncCartPricingUI(cart);
      })
      .catch(() => null);
  }

  let _vrvGiftWrapCheckoutPrep = null;

  function disableGiftWrapCartPatchesForCheckout() {
    if (window.vrvSetGiftWrapCartPatchesEnabled) {
      window.vrvSetGiftWrapCartPatchesEnabled(false);
      return;
    }
    window.__vrvGiftWrapCartPatchesDisabled = true;
    if (window.__vrvFetchBelowGiftWrapPatch) {
      window.fetch = window.__vrvFetchBelowGiftWrapPatch;
    }
  }

  function runGiftWrapCheckoutPrep(skipNuclearRebuild, attempt) {
    const triesLeft = Math.max(0, Number(attempt) || 2);

    return Promise.resolve()
      .then(() => {
        disableGiftWrapCartPatchesForCheckout();
        return rebuildCartDiscountExcludingGiftWrap().catch(() => fetchCartRaw());
      })
      .then(() => fetchCartRaw())
      .then((cart) => {
        if (!cart || !findGiftWrapCartLine(cart) || verifyGiftWrapNotDiscounted(cart)) return cart;
        return swapOrderDiscountToJewelryFixedAmount(cart).then(() => fetchCartRaw());
      })
      .then((cart) => {
        if (skipNuclearRebuild || !cart || verifyGiftWrapNotDiscounted(cart)) return cart;
        return forceNuclearRebuildCartForGiftWrap(cart).then(() => fetchCartRaw());
      })
      .then((cart) => {
        if (!cart || !findGiftWrapCartLine(cart) || verifyGiftWrapNotDiscounted(cart)) return cart;
        return swapOrderDiscountToJewelryFixedAmount(cart).then(() => fetchCartRaw());
      })
      .then((cart) => {
        if (!cart || verifyGiftWrapNotDiscounted(cart) || triesLeft <= 0) return cart;
        return new Promise((resolve) => setTimeout(resolve, 400)).then(() =>
          runGiftWrapCheckoutPrep(true, triesLeft - 1)
        );
      });
  }

  /**
   * Settle Gift Wrap state (remove orphans, force quantity back to 1 — see
   * vrv-gift-wrap.js's requestGiftWrapDependencySync, which already performs
   * both corrections) and hand back the freshly-confirmed cart. Never
   * rejects: a checkout open must always proceed with whatever the real
   * Shopify cart currently is, never a stale pre-settle snapshot and never
   * silently ignored bad state, so this settles first instead of validating
   * and then letting the caller swallow a thrown error and open checkout
   * against unsettled cart contents anyway.
   */
  function prepareGiftWrapCheckoutCart() {
    if (_vrvGiftWrapCheckoutPrep) return _vrvGiftWrapCheckoutPrep;

    const dependencyReady = typeof window.vrvEnsureGiftWrapDependencies === 'function'
      ? window.vrvEnsureGiftWrapDependencies()
      : Promise.resolve();

    _vrvGiftWrapCheckoutPrep = dependencyReady
      .then(() => fetchCartRaw({ bustCache: true }))
      .catch(() => null)
      .finally(() => {
        _vrvGiftWrapCheckoutPrep = null;
      });

    return _vrvGiftWrapCheckoutPrep;
  }

  let _vrvCheckoutOpenGate = Promise.resolve();

  function installOpenRzpCheckoutGuard() {
    if (window.__vrvOpenRzpCheckoutGuardInstalled) return;
    window.__vrvOpenRzpCheckoutGuardInstalled = true;

    function wrapOpenRzp(orig) {
      if (!orig || orig.__vrvGiftWrapGuarded) return orig;

      function guarded(trigger, opts) {
        if (window.__vrvSkipOpenRzpGuardOnce) {
          window.__vrvSkipOpenRzpGuardOnce = false;
          return orig.call(window, trigger, opts);
        }

        _vrvCheckoutOpenGate = _vrvCheckoutOpenGate
          .then(() => {
            const prep =
              typeof window.vrvPrepareGiftWrapCheckoutCart === 'function'
                ? window.vrvPrepareGiftWrapCheckoutCart()
                : Promise.resolve();

            return prep.catch(() => null).then(() => {
              return fetchCartRaw()
                .then((cart) => preparePdpStackedCheckout(cart))
                .catch(() => null);
            });
          })
          .then(() => {
            disableGiftWrapCartPatchesForCheckout();
            return orig.call(window, trigger, opts);
          })
          .catch(() => {
            disableGiftWrapCartPatchesForCheckout();
            return orig.call(window, trigger, opts);
          });

        return _vrvCheckoutOpenGate;
      }

      guarded.__vrvGiftWrapGuarded = true;
      return guarded;
    }

    function patch() {
      if (typeof window.openRzpCheckout !== 'function') return false;
      if (window.openRzpCheckout.__vrvGiftWrapGuarded) return true;
      window.openRzpCheckout = wrapOpenRzp(window.openRzpCheckout);
      return true;
    }

    if (!patch()) {
      const timer = setInterval(() => {
        if (patch()) clearInterval(timer);
      }, 150);
      setTimeout(() => clearInterval(timer), 30000);
    }

    document.addEventListener('vrv:magic-checkout-ready', patch);
  }

  function ensureGiftWrapCheckoutFetchPatch() {
    return prepareGiftWrapCheckoutCart();
  }

  window.vrvPrepareGiftWrapCheckoutCart = prepareGiftWrapCheckoutCart;
  window.vrvPreparePdpStackedCheckout = function () {
    return fetchCartRaw().then((cart) => preparePdpStackedCheckout(cart));
  };
  window.vrvMaintainGiftWrapDiscountIntegrity = maintainGiftWrapDiscountIntegrity;
  window.vrvEnsureGiftWrapCheckoutFetchPatch = ensureGiftWrapCheckoutFetchPatch;
  window.vrvInstallOpenRzpCheckoutGuard = installOpenRzpCheckoutGuard;
  installOpenRzpCheckoutGuard();

  /**
   * Is Razorpay's checkout actually on screen right now?
   *
   * Razorpay never removes its `div.razorpay-container` from the page: it is
   * created once and, on dismiss, only loses the `razorpay-container-visible`
   * class. Treating "the element exists" as "checkout is open" meant a cancelled
   * checkout always looked open, so the saved cart was never restored.
   */
  function isRazorpayCheckoutVisible() {
    if (
      document.querySelector('.razorpay-container-visible') ||
      document.querySelector('.razorpay-thank-you-page-container')
    ) {
      return true;
    }
    const nodes = document.querySelectorAll('.razorpay-container, iframe.razorpay-checkout-frame');
    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];
      if (!node.offsetWidth || !node.offsetHeight) continue;
      const style = window.getComputedStyle(node);
      if (style.display !== 'none' && style.visibility !== 'hidden') return true;
    }
    return false;
  }

  let _vrvBuyNowCloseWatchTimer = null;

  /**
   * After Razorpay has been on screen and then goes away (shopper pressed
   * cancel / X), bring the saved cart back. A light poll while Buy Now is active
   * replaces the old whole-page MutationObserver, which fired on every DOM change
   * on the page (heavy) yet never saw the class-only change on dismiss.
   */
  function watchMagicCheckoutCloseForBuyNow() {
    if (_vrvBuyNowCloseWatchTimer) return;

    let sawCheckoutOpen = false;
    let closedSince = 0;
    let idleTicks = 0;
    let lastHeartbeat = 0;

    _vrvBuyNowCloseWatchTimer = setInterval(() => {
      // Both the in-memory page-load flag AND the session key must be set, so a
      // stale key from an earlier page can never trigger a phantom restore.
      const active = _vrvBuyNowActiveThisLoad && isBuyNowCheckoutActive();
      if (!active) {
        sawCheckoutOpen = false;
        closedSince = 0;
        // Buy Now is starting (flags not set yet) or finished; stop polling if nothing happens.
        idleTicks += 1;
        if (idleTicks > 30 && !_vrvBuyNowStartInFlight) {
          clearInterval(_vrvBuyNowCloseWatchTimer);
          _vrvBuyNowCloseWatchTimer = null;
        }
        return;
      }
      idleTicks = 0;

      // Keep the saved cart's owner heartbeat fresh (~every 5s).
      if (Date.now() - lastHeartbeat > 5000) {
        lastHeartbeat = Date.now();
        touchBuyNowBackup();
      }

      if (isRazorpayCheckoutVisible()) {
        sawCheckoutOpen = true;
        closedSince = 0;
        return;
      }

      // Cart preparation starts before Razorpay shows its window: not visible
      // yet means "not opened yet", not "closed". A failed open restores via the
      // launch promise's catch. But if Razorpay was launched long ago and we
      // never saw it on screen (opened in another window, or cancelled before we
      // polled), treat it as closed too.
      if (!sawCheckoutOpen && !(_vrvBuyNowLaunchedAt && Date.now() - _vrvBuyNowLaunchedAt > 6000)) return;

      // Debounce brief hidden moments between Razorpay's own steps.
      if (!closedSince) {
        closedSince = Date.now();
        return;
      }
      if (Date.now() - closedSince < 600) return;

      sawCheckoutOpen = false;
      closedSince = 0;
      if (!readBuyNowSnapshot()) {
        clearBuyNowSessionKeys();
        return;
      }
      window.vrvRestoreCartSnapshotAfterBuyNow({ silent: true });
    }, 400);
  }

  function waitForRazorpayMagic(maxMs) {
    const limit = Math.max(1000, maxMs || 8000);
    if (typeof window.openRzpCheckout === 'function') return Promise.resolve();

    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        clearInterval(poll);
        reject(new Error('Razorpay checkout is still loading. Please try again.'));
      }, limit);

      const done = () => {
        clearTimeout(timer);
        clearInterval(poll);
        resolve();
      };

      document.addEventListener('vrv:magic-checkout-ready', done, { once: true });
      const poll = setInterval(() => {
        if (typeof window.openRzpCheckout === 'function') done();
      }, 100);
    });
  }

  // FIX (root cause of "Proceed to Checkout gets stuck loading forever"):
  // window.openRzpCheckout is a third-party function (Razorpay's own Magic
  // Checkout script) whose returned promise this file cannot control. Now
  // that its result is actually awaited (see the openRzpCheckout call sites
  // below), a genuine hang inside that third-party call -- rather than a
  // clean resolve/reject -- would leave the checkout button disabled
  // indefinitely with no feedback, which is the exact "does nothing, no
  // error" symptom this fix set out to eliminate, just moved one layer
  // deeper. Bounding the wait guarantees this call always settles one way
  // or the other, so the button is always eventually re-enabled and a
  // failure is always eventually reported.
  function withOpenRzpTimeout(maybePromise, ms) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Error('Checkout is taking longer than expected. Please try again.'));
      }, ms);
      Promise.resolve(maybePromise).then(
        (value) => {
          clearTimeout(timer);
          resolve(value);
        },
        (err) => {
          clearTimeout(timer);
          reject(err);
        }
      );
    });
  }

  function launchRazorpayCartCheckout(trigger) {
    console.log('[CHECKOUT DEBUG] Step 1: launchRazorpayCartCheckout() invoked.');
    clearStaleBuyNowForDrawerCheckout();

    // FIX (root cause of cart/checkout price mismatch, part 3): the combo
    // (Buy 2 for Rs.1699) discount is applied to the real Shopify cart
    // asynchronously by assets/vrv-combo-1699.js, via a background fetch to
    // a Cloudflare Worker that mints/looks up a discount code and applies it
    // with /discount/<code> + /cart/update.js. That means there's a real
    // window, after any cart change, where the live Shopify cart --
    // the actual source of truth for whatever Razorpay charges -- still
    // holds the PREVIOUS discount code/total. This step makes checkout
    // actively confirm (and finish, if not already done) that sync before
    // fetching the cart below, instead of just hoping the background
    // listener already ran. When the cart is already correctly synced (the
    // common case) window.vrvEnsureComboSynced resolves immediately, so this
    // adds no perceptible delay.
    const dependenciesSynced = typeof window.vrvEnsureGiftWrapDependencies === 'function'
      ? window.vrvEnsureGiftWrapDependencies()
      : Promise.resolve();

    console.log('[CHECKOUT DEBUG] Step 2: waiting for gift-wrap dependency sync...');
    const comboSynced =
      typeof window.vrvEnsureComboSynced === 'function'
        ? dependenciesSynced
            .then(() => {
              console.log('[CHECKOUT DEBUG] Step 3: gift-wrap dependency sync done. Waiting for combo discount sync (vrvEnsureComboSynced)...');
              if (window.vrvSetCheckoutLoading) window.vrvSetCheckoutLoading(true);
              return window.vrvEnsureComboSynced();
            })
            .then(() => {
              console.log('[CHECKOUT DEBUG] Step 4: combo discount sync resolved OK.');
              if (window.vrvSetCheckoutLoading) window.vrvSetCheckoutLoading(false);
            }, (err) => {
              console.error('[CHECKOUT DEBUG] Step 4 FAILED: combo discount sync rejected -- checkout stops here.', err);
              if (window.vrvSetCheckoutLoading) window.vrvSetCheckoutLoading(false);
              throw err;
            })
        : dependenciesSynced;

    return comboSynced
      .then(() => {
        console.log('[CHECKOUT DEBUG] Step 5: fetching authoritative cart (bustCache) for checkout validation...');
        return fetchCartRaw({ bustCache: true });
      })
      .then((cart) => {
        console.log('[CHECKOUT DEBUG] Step 6: cart fetched.', {
          item_count: cart && cart.item_count,
          total_price: cart && cart.total_price,
          total_discount: cart && cart.total_discount,
          discount_codes: cart && cart.discount_codes,
        });
        if (cart && Array.isArray(cart.items)) {
          let zeroOrInvalidCount = 0;
          cart.items.forEach((item, idx) => {
            const finalEach = item.quantity ? item.final_line_price / item.quantity : item.final_line_price;
            console.log(
              `[CHECKOUT DEBUG] Cart line ${idx + 1}/${cart.items.length}: "${item.title}" variant_id=${item.variant_id} ` +
              `qty=${item.quantity} price=${item.price} final_price_per_unit=${finalEach} line_price=${item.line_price} ` +
              `final_line_price=${item.final_line_price} discounts=${JSON.stringify(item.line_level_discount_allocations || [])}`
            );
            const invalid = item.price == null || Number.isNaN(Number(item.price));
            const zero = !invalid && Number(finalEach) === 0;
            if (invalid) {
              zeroOrInvalidCount += 1;
              console.error('[CHECKOUT DEBUG] Invalid price on cart line at checkout time:', item.title, 'variant', item.variant_id);
            } else if (zero) {
              zeroOrInvalidCount += 1;
              console.error(
                `[CHECKOUT DEBUG] Rs.0 final price on cart line at checkout time: "${item.title}" (variant ${item.variant_id}). ` +
                'This line is going to checkout priced at zero -- see [CHECKOUT DEBUG][COMBO] logs above for how the active discount was allocated.'
              );
            }
          });
          if (zeroOrInvalidCount > 0) {
            console.warn(`[CHECKOUT DEBUG] Step 6 WARNING: ${zeroOrInvalidCount} cart line(s) have an invalid or Rs.0 price going into checkout.`);
          }
        }
        if (!cart || !Number(cart.item_count)) {
          const hasDomItems = document.querySelectorAll('.vrv-drawer__items .vrv-cart-line, .cart-item, [data-vrv-cart-line]').length > 0;
          if (hasDomItems) {
            console.warn('[CHECKOUT DEBUG] Cart fetch returned empty/null but DOM has items. Falling back to native checkout.');
            window.location.href = '/checkout';
            return { fallbackCheckout: true };
          }
          console.error('[CHECKOUT DEBUG] Step 6 VALIDATION FAILED: cart is empty. Checkout stops here.', cart);
          throw new Error('Your cart is empty. Please add items and try again.');
        }

        if (cart && Array.isArray(cart.items)) {
          for (let i = 0; i < cart.items.length; i++) {
            const item = cart.items[i];
            const domInput = document.querySelector(`input[data-quantity-variant-id="${item.variant_id}"], input[data-line-key="${item.key}"]`);
            if (domInput) {
              const mgmt = domInput.dataset.inventoryManagement;
              const policy = domInput.dataset.inventoryPolicy;
              const invQty = parseInt(domInput.dataset.inventoryQuantity, 10);
              if (mgmt === 'shopify' && policy === 'deny' && !Number.isNaN(invQty) && invQty >= 0) {
                if (item.quantity > invQty) {
                  const title = item.product_title || item.title || 'Item';
                  const errMsg = invQty === 0
                    ? `"${title}" is out of stock. Please remove it from your cart before checkout.`
                    : `Only ${invQty} item${invQty > 1 ? 's are' : ' is'} available in stock for "${title}". Please update quantity.`;
                  
                  if (invQty === 0) {
                    const lineItemEl = domInput.closest('.cart-item, .vrv-cart-line, [role="row"]');
                    if (lineItemEl) {
                      const errEl = lineItemEl.querySelector('.cart-item__error-text, [id*="LineItemError"]');
                      if (errEl) {
                        errEl.textContent = errMsg;
                        setTimeout(() => { errEl.textContent = ''; }, 6000);
                      }
                    }
                  }
                  throw new Error(errMsg);
                }
              }
            }
          }
        }
        console.log('[CHECKOUT DEBUG] Step 7: validating/applying any pending PDP stacked offer...');
        return preparePdpStackedCheckout(cart).then((prepped) => prepped || cart);
      })
      .then((cart) => {
        if (!cart || !Number(cart.item_count)) {
          const hasDomItems = document.querySelectorAll('.vrv-drawer__items .vrv-cart-line, .cart-item, [data-vrv-cart-line]').length > 0;
          if (hasDomItems) {
            console.warn('[CHECKOUT DEBUG] Step 7: cart empty after PDP offer prep but DOM has items. Falling back to native checkout.');
            window.location.href = '/checkout';
            return { fallbackCheckout: true };
          }
          console.error('[CHECKOUT DEBUG] Step 7 VALIDATION FAILED: cart became empty after PDP offer prep. Checkout stops here.', cart);
          throw new Error('Your cart is empty. Please add items and try again.');
        }
        console.log('[CHECKOUT DEBUG] Step 8: checking for a gift-wrap line requiring special discount handling...');
        if (findGiftWrapCartLine(cart)) {
          console.log('[CHECKOUT DEBUG] Step 8: gift-wrap line found -- running gift-wrap checkout prep before opening Razorpay.');
          return prepareGiftWrapCheckoutCart()
            .then(() => {
              console.log('[CHECKOUT DEBUG] Step 9: gift-wrap checkout prep done. Waiting for Razorpay Magic Checkout script to be ready...');
              return waitForRazorpayMagic();
            })
            .then(() => {
              console.log('[CHECKOUT DEBUG] Step 10: Razorpay Magic Checkout is ready (window.openRzpCheckout exists).');
              if (typeof window.openRzpCheckout !== 'function') {
                console.error('[CHECKOUT DEBUG] Step 10 VALIDATION FAILED: window.openRzpCheckout is not a function. Checkout stops here.');
                throw new Error('Checkout is unavailable right now. Please refresh and try again.');
              }
              window.__vrvSkipOpenRzpGuardOnce = true;
              // FIX (root cause of "checkout silently does nothing"):
              // window.openRzpCheckout is Razorpay's own Magic Checkout
              // function -- it does real async work (fetching the cart,
              // creating the order, opening the payment iframe) and can
              // reject if that work fails. This call used to fire it and
              // immediately `return true`, discarding whatever promise it
              // returned. Any async failure inside Razorpay's own flow
              // (more likely to surface on a large/complex cart) became an
              // unhandled promise rejection: invisible in the UI, with the
              // button already re-enabled and no alert ever shown. Awaiting
              // it here routes real failures into this same function's
              // existing catch -> window.alert reporting instead of
              // swallowing them.
              console.log('[CHECKOUT DEBUG] Step 11: calling window.openRzpCheckout(pageType: cart) [gift-wrap path]...');
              return withOpenRzpTimeout(window.openRzpCheckout(trigger || null, { pageType: 'cart' }), 20000)
                .then(() => {
                  console.log('[CHECKOUT DEBUG] Step 12: window.openRzpCheckout resolved OK -- Razorpay Magic Checkout should now be open.');
                  return true;
                })
                .catch((err) => {
                  console.error('[CHECKOUT DEBUG] Step 12 FAILED: openRzpCheckout rejected/timed out (gift wrap cart). Checkout stops here.', err);
                  throw err;
                });
            });
        }
        if (findGiftWrapCartLine(cart) && !verifyGiftWrapNotDiscounted(cart)) {
          console.error(
            '[VRV gift wrap] Gift wrap is still discounted before Razorpay checkout after all fix attempts.\n' +
              'To permanently fix this, ONE of the following is required:\n' +
              '  A) Shopify Admin → Discounts → [30% discount] → "Applies to" → change from "All products"\n' +
              '     to specific jewellery collections that do NOT include the Gift Wrap product/collection.\n' +
              '  B) Theme settings → Gift Wrap → set "Jewellery-only mirror coupon" (e.g. NEW30J) to a\n' +
              '     discount code scoped to jewellery collections only (Gift Wrap collection excluded).\n' +
              'Checkout is being blocked to prevent charging the wrong price for Gift Wrap.'
          );
          throw new Error(
            'We could not apply the correct price for Gift Wrap. Please remove Gift Wrap from your cart and try checking out again.'
          );
        }
        console.log('[CHECKOUT DEBUG] Step 9: no gift-wrap line. Waiting for Razorpay Magic Checkout script to be ready...');
        return waitForRazorpayMagic().then(() => {
          console.log('[CHECKOUT DEBUG] Step 10: Razorpay Magic Checkout is ready (window.openRzpCheckout exists).');
          disableGiftWrapCartPatchesForCheckout();
          if (typeof window.openRzpCheckout !== 'function') {
            console.error('[CHECKOUT DEBUG] Step 10 VALIDATION FAILED: window.openRzpCheckout is not a function. Checkout stops here.');
            throw new Error('Checkout is unavailable right now. Please refresh and try again.');
          }
          window.__vrvGiftWrapPrepDoneAt = Date.now();
          window.__vrvSkipOpenRzpGuardOnce = true;
          // Same fix as the gift-wrap branch above: propagate a real failure
          // from Razorpay's own checkout-opening promise instead of firing
          // it and moving on regardless of the outcome.
          console.log('[CHECKOUT DEBUG] Step 11: calling window.openRzpCheckout(pageType: cart)...');
          return withOpenRzpTimeout(window.openRzpCheckout(trigger || null, { pageType: 'cart' }), 20000)
            .then(() => {
              console.log('[CHECKOUT DEBUG] Step 12: window.openRzpCheckout resolved OK -- Razorpay Magic Checkout should now be open.');
              return true;
            })
            .catch((err) => {
              console.error('[VRV checkout] openRzpCheckout rejected/timed out. Falling back to standard checkout.', err);
              window.location.href = '/checkout';
              return true;
            });
        });
      });
  }

  window.vrvLaunchRazorpayCartCheckout = launchRazorpayCartCheckout;

  function launchRazorpayBuyNowCheckout(trigger) {
    watchMagicCheckoutCloseForBuyNow();

    // Fast path: the temporary cart was just built by us (cleared, then exactly
    // the Buy Now product added and confirmed), and there is no gift wrap to
    // settle. Gift-wrap dependency sync, discount checks and re-reading /cart.js
    // (three extra round trips) cannot change anything, so open Razorpay now.
    if (isBuyNowCartReady() && !_vrvBuyNowHasGiftWrap) {
      return waitForRazorpayMagic().then(() => {
        disableGiftWrapCartPatchesForCheckout();
        if (typeof window.vrvUseNativeFetchForBuyNow === 'function') {
          window.vrvUseNativeFetchForBuyNow(true);
        }
        if (typeof window.openRzpCheckout !== 'function') {
          throw new Error('Checkout is unavailable right now. Please refresh and try again.');
        }
        window.__vrvGiftWrapPrepDoneAt = Date.now();
        window.__vrvSkipOpenRzpGuardOnce = true;
        return withOpenRzpTimeout(window.openRzpCheckout(trigger || null, { pageType: 'cart' }), 20000)
          .then(() => true)
          .catch((err) => {
            console.error('[VRV checkout] openRzpCheckout failed (buy now)', err);
            window.location.href = '/checkout';
            return true;
          });
      });
    }

    return Promise.resolve()
      .then(() => {
        if (typeof window.vrvPrepareGiftWrapCheckoutCart === 'function') {
          return window.vrvPrepareGiftWrapCheckoutCart({ skipNuclearRebuild: false });
        }
        return null;
      })
      .then(() => fetchCartRaw({ bustCache: true }))
      .then((cart) => {
        if (!cart || !Number(cart.item_count)) {
          throw new Error('Your cart is empty. Please try again.');
        }
        if (findGiftWrapCartLine(cart)) {
          return prepareGiftWrapCheckoutCart()
            .then(() => waitForRazorpayMagic())
            .then(() => {
              if (typeof window.openRzpCheckout !== 'function') {
                throw new Error('Checkout is unavailable right now. Please refresh and try again.');
              }
              window.__vrvSkipOpenRzpGuardOnce = true;
              // Same fix as launchRazorpayCartCheckout above: don't discard
              // the promise Razorpay's own checkout call returns.
              return withOpenRzpTimeout(window.openRzpCheckout(trigger || null, { pageType: 'cart' }), 20000)
                .then(() => true)
                .catch((err) => {
                  console.error('[VRV checkout] openRzpCheckout failed (buy now, gift wrap)', err);
                  throw err;
                });
            });
        }
        return waitForRazorpayMagic().then(() => {
          disableGiftWrapCartPatchesForCheckout();
          if (typeof window.vrvUseNativeFetchForBuyNow === 'function') {
            window.vrvUseNativeFetchForBuyNow(true);
          }
          if (typeof window.openRzpCheckout !== 'function') {
            throw new Error('Checkout is unavailable right now. Please refresh and try again.');
          }
          window.__vrvGiftWrapPrepDoneAt = Date.now();
          window.__vrvSkipOpenRzpGuardOnce = true;
          return withOpenRzpTimeout(window.openRzpCheckout(trigger || null, { pageType: 'cart' }), 20000)
            .then(() => true)
            .catch((err) => {
              console.error('[VRV checkout] openRzpCheckout failed (buy now)', err);
              window.location.href = '/checkout';
              return true;
            });
        });
      });
  }

  window.vrvLaunchRazorpayBuyNowCheckout = launchRazorpayBuyNowCheckout;

  function openMagicCheckoutPreview(trigger) {
    if (typeof window.vrvOpenRzpPreviewPopup === 'function') {
      try {
        if (window.vrvOpenRzpPreviewPopup(trigger || null)) {
          return Promise.resolve(true);
        }
      } catch (_) {
        /* fall through */
      }
    }

    const launch = isBuyNowCheckoutActive() ? launchRazorpayBuyNowCheckout : launchRazorpayCartCheckout;

    return launch(trigger).catch((err) => {
      console.warn('[VRV checkout]', err);
      const hasDomItems = document.querySelectorAll('.vrv-drawer__items .vrv-cart-line, .cart-item, [data-vrv-cart-line]').length > 0;
      if (hasDomItems) {
        window.location.href = '/checkout';
        return true;
      }
      window.alert((err && err.message) || 'Could not open checkout. Please try again.');
      return false;
    });
  }

  /** Same entry as cart drawer Proceed to Checkout — opens Razorpay preview, never opens drawer. */
  window.vrvProceedToCheckoutPreview = function (trigger, options) {
    const opts = options || {};
    const isBuyNow = isBuyNowCheckoutActive();

    function launchBuyNowCheckout() {
      return openMagicCheckoutPreview(trigger).then((opened) => {
        if (opened) _vrvBuyNowLaunchedAt = Date.now();
        clearBuyNowCartReady();
        if (!opened) {
          const err = new Error('Checkout could not be opened. Please try again.');
          err.code = 'VRV_BUY_NOW_CHECKOUT_UNAVAILABLE';
          throw err;
        }
        return true;
      });
    }

    if (isBuyNow) {
      const openNow = opts.cartReady || isBuyNowCartReady();

      const checkoutPromise = openNow
        ? launchBuyNowCheckout()
        : waitForNonemptyCart(12, 100).then(() => launchBuyNowCheckout());

      return checkoutPromise.catch((err) => {
        console.warn('Buy Now checkout failed', err);
        clearBuyNowCartReady();
        if (typeof window.vrvRestoreCartSnapshotAfterBuyNow === 'function') {
          return window.vrvRestoreCartSnapshotAfterBuyNow({ silent: true }).then(() => {
            throw err;
          });
        }
        throw err;
      });
    }

    if (!enableDrawerCheckoutButton()) {
      return openMagicCheckoutPreview(trigger).then((opened) => Boolean(opened));
    }

    return openMagicCheckoutPreview(trigger).then((opened) => Boolean(opened));
  };

  window.vrvOpenCartDrawer = function (trigger) {
    const drawer = getCartDrawer();
    if (!drawer || typeof drawer.open !== 'function') return false;
    drawer.open(trigger || document.querySelector('#cart-icon-bubble') || document.activeElement);

    const staleMs = 8000;
    const lastRefresh = drawer._vrvLastRefreshAt || 0;
    if (typeof drawer.refreshDrawer === 'function' && Date.now() - lastRefresh > staleMs) {
      drawer._vrvLastRefreshAt = Date.now();
      drawer.refreshDrawer().catch(() => {});
    }
    return true;
  };

  let _vrvCouponsOpenAt = 0;

  window.vrvOpenCouponsDrawer = function (trigger) {
    // The PDP "Get this as low as" button is wired both by the PDP script and
    // by the global document click handler, so one tap used to run this twice:
    // the second run toggled/re-opened the drawer mid-animation and left it
    // blank. Collapse near-simultaneous calls into one.
    const now = Date.now();
    if (now - _vrvCouponsOpenAt < 700) return true;
    _vrvCouponsOpenAt = now;

    const drawer = getCartDrawer();
    const showCoupons = () => {
      const stale = drawer && !drawer.querySelector('.vrv-drawer__items, .cart-item, .vrv-cart-line, [data-vrv-offer-card]');
      if (stale && typeof drawer.refreshDrawer === 'function') {
        drawer._vrvLastRefreshAt = Date.now();
        drawer.refreshDrawer().catch(() => {}).then(() => openCouponsPage());
        return;
      }
      openCouponsPage();
    };
    if (drawer && drawer.classList.contains('active')) {
      showCoupons();
      return true;
    }
    if (window.vrvOpenCartDrawer(trigger)) {
      setTimeout(showCoupons, 320);
      return true;
    }
    return false;
  };

  window.vrvGetCartAddSections = getSectionIds;

  function getCouponErrorEl() {
    return document.getElementById('CartPage-CouponError') || document.getElementById('CartDrawer-CouponError');
  }

  function getCouponInputEl() {
    return document.getElementById('CartPage-CouponInput') || document.getElementById('CartDrawer-CouponInput');
  }

  function getCouponsPageErrorEl() {
    return document.getElementById('CartDrawer-CouponsPageError');
  }

  function showCouponError(message, sourceBtn) {
    const drawer = getCartDrawer();
    const onCouponsPage = drawer && drawer.classList.contains('is-coupons-open');

    if (onCouponsPage) {
      const pageErr = getCouponsPageErrorEl();
      if (pageErr) {
        pageErr.textContent = message;
        pageErr.hidden = false;
        clearTimeout(pageErr._vrvHideTimer);
        pageErr._vrvHideTimer = setTimeout(() => {
          pageErr.hidden = true;
          pageErr.textContent = '';
        }, 5000);
      }
      if (sourceBtn) {
        const card = sourceBtn.closest('.vrv-offer-card');
        if (card) {
          card.classList.add('has-error');
          clearTimeout(card._vrvErrTimer);
          card._vrvErrTimer = setTimeout(() => card.classList.remove('has-error'), 1800);
        }
      }
    }

    const errorEl = getCouponErrorEl();
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      clearTimeout(errorEl._vrvHideTimer);
      errorEl._vrvHideTimer = setTimeout(() => {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }, 5000);
    }
  }

  function clearCouponErrors() {
    [getCouponErrorEl(), getCouponsPageErrorEl()].forEach((el) => {
      if (!el) return;
      el.hidden = true;
      el.textContent = '';
      clearTimeout(el._vrvHideTimer);
    });
  }

  function showAppliedCouponRow(code, sourceBtn) {
    if (!sourceBtn || !code) return;
    const inputRow = sourceBtn.closest('.vrv-drawer__coupon-input-row, .vrv-cart-page__promo-input-wrap');
    if (!inputRow) return;

    const isPage = inputRow.classList.contains('vrv-cart-page__promo-input-wrap');
    const upper = String(code).trim().toUpperCase();
    const applied = document.createElement('div');
    applied.setAttribute('data-vrv-coupon-applied', '');

    if (isPage) {
      applied.className = 'vrv-cart-page__coupon-applied vrv-cart-page__coupon-applied--inline';
    } else {
      applied.className = 'vrv-drawer__coupon-applied vrv-drawer__coupon-applied--inline';
    }

    const icon = document.createElement('span');
    icon.className = isPage ? 'vrv-cart-page__coupon-applied-icon' : 'vrv-drawer__coupon-applied-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

    const info = document.createElement('div');
    info.className = isPage ? 'vrv-cart-page__coupon-applied-info' : 'vrv-drawer__coupon-applied-info';

    const head = document.createElement('div');
    head.className = isPage ? 'vrv-cart-page__coupon-applied-head' : 'vrv-drawer__coupon-applied-head';

    const badge = document.createElement('span');
    badge.className = isPage
      ? 'vrv-cart-page__coupon-applied-badge vrv-cart-page__coupon-applied-badge--manual'
      : 'vrv-drawer__coupon-applied-badge vrv-drawer__coupon-applied-badge--manual';
    badge.textContent = 'Applied';

    const codeEl = document.createElement('span');
    codeEl.className = isPage ? 'vrv-cart-page__coupon-applied-code' : 'vrv-drawer__coupon-applied-code';
    codeEl.textContent = upper;

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = isPage ? 'vrv-cart-page__coupon-remove-btn' : 'vrv-drawer__coupon-remove-btn';
    removeBtn.setAttribute('data-vrv-remove-discount', '');
    removeBtn.setAttribute('aria-label', 'Remove coupon');
    removeBtn.textContent = 'Remove';

    head.appendChild(badge);
    head.appendChild(codeEl);
    info.appendChild(head);
    applied.appendChild(icon);
    applied.appendChild(info);
    applied.appendChild(removeBtn);

    const promo = inputRow.closest('.vrv-cart-page__promo');
    if (promo) {
      const barCopy = promo.querySelector('.vrv-cart-page__promo-bar-copy');
      if (barCopy) barCopy.style.display = 'none';
      const label = promo.querySelector('.vrv-cart-page__promo-label');
      if (label) label.style.display = 'none';
    }

    const err = inputRow.nextElementSibling;
    if (err && (err.classList.contains('vrv-drawer__coupon-error') || err.classList.contains('vrv-cart-page__promo-error'))) {
      err.hidden = true;
      err.textContent = '';
    }

    inputRow.replaceWith(applied);
    removeBtn.addEventListener('click', removeDiscount);
  }

  // FIX (contributes to "extra coupon being added unexpectedly"): the
  // coupon input's Enter-keydown handler and the Apply button's click
  // handler both call applyDiscount() independently, and on some
  // touch/mobile keyboards a single "Go"/Enter action can trigger both in
  // the same tick, before either has a chance to disable its target. That
  // let two concurrent /cart/update.js discount-apply requests race for the
  // same cart. This guard makes concurrent calls to applyDiscount() no-ops.
  let couponApplyInFlight = false;

  function applyDiscount(code, sourceBtn) {
    if (couponApplyInFlight) return Promise.resolve();
    clearCouponErrors();

    if (!code || !String(code).trim()) {
      showCouponError('Please enter a coupon code', sourceBtn);
      return Promise.resolve();
    }

    const trimmed = String(code).trim();
    const normalized = normalizeDiscountCode(trimmed);

    if (sourceBtn && normalized.startsWith('VRVCMBO')) {
      showCouponError('This combo offer is applied automatically and cannot be added manually.', sourceBtn);
      return Promise.resolve();
    }



    clearAllDismissedDiscounts();
    try {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem('vrvAutoApplyBlocked:' + trimmed);
      }
    } catch (_) {}

    if (sourceBtn) {
      sourceBtn.dataset.vrvOriginalLabel = sourceBtn.textContent.trim();
      sourceBtn.setAttribute('aria-busy', 'true');
      sourceBtn.disabled = true;
      sourceBtn.textContent = 'Applying…';
    }

    const restoreButton = () => {
      if (!sourceBtn) return;
      sourceBtn.removeAttribute('aria-busy');
      sourceBtn.disabled = false;
      if (sourceBtn.dataset.vrvOriginalLabel) {
        sourceBtn.textContent = sourceBtn.dataset.vrvOriginalLabel;
        delete sourceBtn.dataset.vrvOriginalLabel;
      }
    };

    couponApplyInFlight = true;

    return prepareCartForDiscountApply(trimmed)
      .then((prep) => {
        if (prep.alreadyApplied && prep.cart) {
          return finishSuccessfulDiscountApply(prep.cart, normalized, sourceBtn, restoreButton);
        }

        return fetchFreshCart().then((cart) => {
          const comboCheck = Promise.resolve(false);
          return comboCheck.then((hasCombo) => {
            if (hasCombo) {
              showCouponError('Coupons cannot be applied along with Combo offers.', sourceBtn);
              restoreButton();
              return window.vrvEnsureComboSynced
                ? window.vrvEnsureComboSynced().then(() => ({ alreadyApplied: true, comboBlocked: true, cart }))
                : { alreadyApplied: true, comboBlocked: true, cart };
            }
            const applyCode = mapCouponForGiftWrapCart(normalized, cart) || normalized;
            return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify(buildCartUpdateBody({ discount: applyCode })),
            }).then((res) => res.json().then((data) => ({ data, ok: res.ok, status: res.status, applyCode })));
          });
        });
      })
      .then((result) => {
        if (!result || result.alreadyApplied) return result;

        const { data, ok, status, applyCode } = result;
        const effectiveCode = applyCode || normalized;
        if (!ok || (data && data.status && data.message)) {
          const msg =
            (data && (data.description || data.message)) ||
            (status === 422
              ? `Coupon "${normalized}" could not be applied. Check minimum cart value or expiry.`
              : 'Invalid coupon code. Please try again.');
          showCouponError(msg, sourceBtn);
          restoreButton();
          return;
        }

        if (discountEffectivelyActive(data, effectiveCode)) {
          return finishSuccessfulDiscountApply(data, normalized, sourceBtn, restoreButton);
        }

        // FIX: same combo/coupon race as attemptDiscountApply() above -- give
        // the combo engine a chance to fold this code into its composite
        // discount before re-checking, instead of racing its ~1s background
        // debounce and reporting "could not be applied" for a code that
        // actually did take effect.
        const comboSettledForCoupon =
          typeof window.vrvEnsureComboSynced === 'function'
            ? window.vrvEnsureComboSynced().catch(() => null)
            : Promise.resolve();

        return comboSettledForCoupon.then(() => fetchFreshCart()).then((fresh) => {
          if (fresh && discountEffectivelyActive(fresh, effectiveCode)) {
            return finishSuccessfulDiscountApply(fresh, normalized, sourceBtn, restoreButton);
          }

          const codes = (data && data.discount_codes) || [];
          const codeEntry = codes.find(
            (c) => c && c.code && c.code.toLowerCase() === effectiveCode.toLowerCase()
          );
          if (codeEntry && codeEntry.applicable === false && cartHasLineLevelDiscount(data, effectiveCode)) {
            return finishSuccessfulDiscountApply(data, normalized, sourceBtn, restoreButton);
          }
          const msg =
            codeEntry && codeEntry.applicable === false
              ? `"${normalized}" is not applicable to this cart (minimum value, expiry or eligibility).`
              : `Coupon "${normalized}" could not be applied.`;
          showCouponError(msg, sourceBtn);
          restoreButton();
        });
      })
      .catch(() => {
        showCouponError('Could not connect. Please check your network and try again.', sourceBtn);
        restoreButton();
      })
      .finally(() => {
        couponApplyInFlight = false;
      });
  }

  /** Read the codes currently shown as "applied" inside the cart drawer / page.
   *  Optionally narrow to a specific Remove button's surrounding container so the
   *  cart-page markup (no dedicated code class) is handled too. */
  function getDisplayedAppliedCodes(scopeBtn) {
    const codes = new Set();

    const harvestFrom = (root) => {
      if (!root) return;
      const codeEl = root.querySelector('.vrv-drawer__coupon-applied-code, .vrv-cart-page__coupon-applied-code');
      if (codeEl) {
        (codeEl.textContent || '').split(',').forEach((raw) => {
          const code = raw.trim();
          if (code) codes.add(code);
        });
        return;
      }
      // Fallback: the cart-page snippet just prints <strong>{{ discount.title }}</strong>.
      const fallbackEl = root.querySelector('strong');
      if (fallbackEl) {
        const code = (fallbackEl.textContent || '').trim();
        if (code) codes.add(code);
      }
    };

    if (scopeBtn) {
      harvestFrom(scopeBtn.closest('.vrv-drawer__coupon-applied, .vrv-page-offers__applied') || document);
    } else {
      document
        .querySelectorAll('.vrv-drawer__coupon-applied, .vrv-page-offers__applied')
        .forEach(harvestFrom);
    }
    return Array.from(codes);
  }

  /** Mark a code as user-removed so the auto-apply loop won't immediately re-attach it. */
  function blockAutoApplyForCode(code) {
    if (!code) return;
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem('vrvAutoApplyBlocked:' + code, '1');
        // Also keep the "already tried" flag so the existing guard fires too.
        window.sessionStorage.setItem('vrvAutoApply:' + code, '1');
      }
    } catch (_) {}
  }

  /**
   * Theme-settings-driven private/hidden codes (window.vrvHiddenCodes is set
   * once in layout/theme.liquid). Used to gate auto-apply attempts so a hidden
   * code can never be silently re-attached by our scripts. Hidden codes can
   * still be applied when the customer manually types them — Shopify itself
   * validates the code against the Admin → Discounts list at checkout.
   */
  function isHiddenCode(code) {
    if (!code) return false;
    const normalized = String(code).trim().toUpperCase();
    if (normalized.startsWith('VRVGW')) return true;
    try {
      const map = window.vrvHiddenCodes || {};
      return !!map[String(code).trim().toLowerCase()];
    } catch (_) {
      return false;
    }
  }

  /**
   * Per-session list of discount codes the customer has explicitly dismissed
   * via the cart "Remove" button. Used to visually hide the applied-coupon
   * card even when Shopify automatically re-attaches the discount (true
   * "Automatic Discounts" created in Admin → Discounts → Automatic, or
   * codes re-applied by a third-party app / URL param like ?discount=).
   *
   * This is a UI-only hide — the discount itself may still apply at checkout
   * if Shopify enforces it. The small "auto-applied at checkout" note below
   * the input keeps the customer informed.
   */
  const DISMISSED_KEY = 'vrvDismissedDiscounts';

  function getDismissedDiscounts() {
    try {
      if (!window.sessionStorage) return new Set();
      const raw = window.sessionStorage.getItem(DISMISSED_KEY) || '[]';
      const arr = JSON.parse(raw);
      return new Set(Array.isArray(arr) ? arr.map((c) => String(c).toUpperCase()) : []);
    } catch (_) {
      return new Set();
    }
  }

  function saveDismissedDiscounts(set) {
    try {
      if (!window.sessionStorage) return;
      window.sessionStorage.setItem(DISMISSED_KEY, JSON.stringify(Array.from(set)));
    } catch (_) {}
  }

  function addDismissedDiscount(code) {
    if (!code) return;
    const set = getDismissedDiscounts();
    set.add(String(code).toUpperCase());
    saveDismissedDiscounts(set);
  }

  function clearDismissedDiscount(code) {
    if (!code) return;
    const set = getDismissedDiscounts();
    if (set.delete(String(code).toUpperCase())) saveDismissedDiscounts(set);
  }

  function clearAllDismissedDiscounts() {
    saveDismissedDiscounts(new Set());
  }

  function dismissAllDiscountsOnCart(cart) {
    if (!cart) return;
    (cart.discount_applications || []).forEach((d) => {
      if (!d || !d.title || d.target_type === 'shipping_line') return;
      if (!d.total_allocated_amount || d.total_allocated_amount <= 0) return;
      addDismissedDiscount(d.title);
      blockAutoApplyForCode(d.title);
    });
    (cart.discount_codes || []).forEach((c) => {
      if (!c || !c.code) return;
      addDismissedDiscount(c.code);
      blockAutoApplyForCode(c.code);
    });
  }

  function cartDiscountApps(cartData) {
    return (cartData.discount_applications || []).filter((d) => {
      if (!d || d.target_type === 'shipping_line' || !d.total_allocated_amount) return false;
      const title = String(d.title || '').toUpperCase();
      return !title.includes('VRVCMBO') && !title.includes('BUY 2 AT') && !title.includes('COMBO') && !title.includes('1699');
    });
  }

  function isCouponAppliedInUi() {
    const roots = document.querySelectorAll('[data-vrv-cart-offers]');
    for (const root of roots) {
      if (!root || !root.isConnected) continue;

      const appliedNodes = root.querySelectorAll('[data-vrv-coupon-applied]');
      for (const applied of appliedNodes) {
        const parentToolbar = applied.closest('.vrv-drawer__coupon-toolbar');
        if (parentToolbar) {
          if (parentToolbar.dataset.vrvHidden === '1') continue;
          const toolbarStyle = window.getComputedStyle(parentToolbar);
          if (toolbarStyle.display === 'none' || toolbarStyle.visibility === 'hidden') continue;
        }

        const appliedStyle = window.getComputedStyle(applied);
        if (appliedStyle.display === 'none' || appliedStyle.visibility === 'hidden') continue;
        return true;
      }
    }
    return false;
  }

  function cartHasUndismissedDiscount(cartData) {
    if (!cartData) return false;
    const dismissed = getDismissedDiscounts();
    if (
      cartDiscountApps(cartData).some(
        (d) => !dismissed.has(String(d.title || '').trim().toUpperCase())
      )
    ) {
      return true;
    }

    const orig = cartData.original_total_price;
    const tot = cartData.total_price;
    if (typeof orig === 'number' && typeof tot === 'number' && tot < orig) {
      for (const item of cartData.items || []) {
        for (const alloc of item.line_level_discount_allocations || []) {
          const title = alloc?.discount_application?.title;
          if (!title || !alloc.amount) continue;
          if (!dismissed.has(String(title).trim().toUpperCase())) return true;
        }
        for (const d of item.discounts || []) {
          if (!d?.title || !d.amount) continue;
          if (!dismissed.has(String(d.title).trim().toUpperCase())) return true;
        }
      }
    }

    const codes = cartData.discount_codes || [];
    if (
      codes.some(
        (c) => c && c.code && c.applicable !== false && !dismissed.has(String(c.code).trim().toUpperCase())
      )
    ) {
      return true;
    }

    return false;
  }

  /** Real (not predicted) combo state, mirroring has_combo_applied in snippets/vrv-cart-drawer-offers.liquid. */
  function isRealComboDiscountActive(cartData) {
    return false;
  }

  function syncCartLinePrices(cartData, formatMoney, showDiscount) {
    const giftHelpers = window.vrvGiftWrapHelpers || {};
    const isGiftWrapItem =
      typeof giftHelpers.isGiftWrapCartItem === 'function'
        ? giftHelpers.isGiftWrapCartItem
        : () => false;

    // FIX (root cause of "cart shows 'COMBO 1699 APPLIED' + a discounted
    // price on items the real Shopify discount never actually covered,
    // while the 'Checking best offer...' banner stays stuck"): the pairing
    // simulation below predicts, client-side, which items WOULD form a
    // combo pair and shows them at a flat 84950 (Rs.1699 / 2) with a combo
    // badge -- but it used to do this purely from `showDiscount`, a
    // cart-WIDE "is ANY discount active at all" flag (cartHasUndismissedDiscount),
    // completely independent of whether a combo discount specifically is the
    // one that's actually active, or whether THIS particular pair is the one
    // it covers. The moment any other discount (or, after the earlier
    // pairTotal-grouping fix, a combo covering a DIFFERENT pairTotal group)
    // was active anywhere in the cart, every other eligible-looking pair
    // rendered the fabricated "applied" badge/price even though Shopify's
    // real cart.discount_applications never touched those lines -- directly
    // contradicting the "Checking best offer" banner, which correctly stays
    // visible until a real VRVCMBO/"Buy 2 at" discount is confirmed. Gating
    // the predicted values on that same real signal keeps both pieces of UI
    // telling the same story: no invented "applied" state before Shopify has
    // actually applied it.
    const comboReallyActive = isRealComboDiscountActive(cartData);
    if (!comboReallyActive) {
      console.log(
        '[CHECKOUT DEBUG][COMBO] syncCartLinePrices(): no real VRVCMBO/"Buy 2 at" discount on the cart yet -- ' +
        'line prices/badges below will show real Shopify prices only, not the predicted combo split.'
      );
    }

    let expectedTotalLinePrices = {};
    // FIX: a line whose quantity is only PARTLY combo-paired (e.g. qty 3 of
    // the same product = one self-pair + one leftover unit) used to only get
    // a single blended "average" unit price across all its units, which hid
    // which units actually earned the combo discount. To split the display
    // (2 units shown together at the combo price, 1 shown separately at
    // regular price) we need per-idx counts of how many units actually
    // landed in a real (threshold-clearing) discounted pair, not just the
    // total rupee amount. `pairedQtyByIdx`/`pairedTotalByIdx` track exactly
    // that, in parallel with the existing pairing loop below -- the pairing
    // decision itself (who gets paired with whom, and the 169900 threshold)
    // is untouched.
    let pairedQtyByIdx = {};
    let pairedTotalByIdx = {};
    if (cartData && cartData.items) {
      const eligibleForAuto = [];
      cartData.items.forEach((item, idx) => {
        expectedTotalLinePrices[idx] = 0;
        pairedQtyByIdx[idx] = 0;
        pairedTotalByIdx[idx] = 0;
        if (isGiftWrapItem(item) || (item.properties && item.properties['VrvGiftWrap'])) {
           expectedTotalLinePrices[idx] += item.original_line_price;
        } else if (item.properties && item.properties['VrvComboId']) {
           expectedTotalLinePrices[idx] += item.original_line_price;
        } else if (item.title && item.title.toUpperCase().includes('COMBO')) {
           expectedTotalLinePrices[idx] += 169900 * item.quantity;
        } else if (item.original_price <= 149900) {
           for (let q = 0; q < item.quantity; q++) {
              eligibleForAuto.push({price: item.original_price, idx: idx});
           }
        } else {
           expectedTotalLinePrices[idx] += item.original_line_price;
        }
      });
      eligibleForAuto.sort((a, b) => b.price - a.price);
      const pairsCount = Math.floor(eligibleForAuto.length / 2);
      for (let i = 0; i < pairsCount; i++) {
         let e1 = eligibleForAuto[i*2];
         let e2 = eligibleForAuto[i*2 + 1];
         let pairTotal = e1.price + e2.price;
         if (pairTotal > 169900) {
            expectedTotalLinePrices[e1.idx] += 84950;
            expectedTotalLinePrices[e2.idx] += 84950;
            pairedQtyByIdx[e1.idx] += 1;
            pairedQtyByIdx[e2.idx] += 1;
            pairedTotalByIdx[e1.idx] += 84950;
            pairedTotalByIdx[e2.idx] += 84950;
         } else {
            expectedTotalLinePrices[e1.idx] += e1.price;
            expectedTotalLinePrices[e2.idx] += e2.price;
         }
      }
      for (let i = pairsCount * 2; i < eligibleForAuto.length; i++) {
         let e = eligibleForAuto[i];
         expectedTotalLinePrices[e.idx] += e.price;
      }
    }

    (cartData.items || []).forEach((item, idx) => {
      const lineIndex = typeof item.index === 'number' ? item.index : idx + 1;
      // Only trust the predicted pairing total once a real combo discount is
      // confirmed active on the cart -- otherwise this line's REAL, current
      // Shopify price is the only thing that should ever be displayed.
      let calculatedTotal = comboReallyActive
        ? (expectedTotalLinePrices[idx] || item.final_line_price)
        : item.final_line_price;
      const pairedQtyForLine = comboReallyActive ? (pairedQtyByIdx[idx] || 0) : 0;

      const unitFinal = item.quantity > 0 ? Math.round(calculatedTotal / item.quantity) : calculatedTotal;
      const unitOrig = item.quantity > 0 ? Math.round(item.original_line_price / item.quantity) : item.original_price;
      const skipLineDiscount = isGiftWrapItem(item) || (item.properties && item.properties['VrvGiftWrap']);
      const hasDiscount =
        showDiscount &&
        !skipLineDiscount &&
        typeof unitFinal === 'number' &&
        typeof unitOrig === 'number' &&
        unitFinal < unitOrig;

      const pairedQty = pairedQtyForLine;
      const leftoverQty = item.quantity - pairedQty;
      const isMixedLine = hasDiscount && pairedQty > 0 && leftoverQty > 0;

      document
        .querySelectorAll(
          `#CartDrawer-Item-${lineIndex}, #CartItem-${lineIndex}`
        )
        .forEach((rowEl) => {
          const priceEl = rowEl.querySelector('.vrv-cart-line__price');
          const existingSplit =
            rowEl.nextElementSibling &&
            rowEl.nextElementSibling.classList &&
            rowEl.nextElementSibling.classList.contains('vrv-cart-line__split-extra')
              ? rowEl.nextElementSibling
              : null;

          if (isMixedLine) {
            const pairedUnit = Math.round(pairedTotalByIdx[idx] / pairedQty);
            const leftoverTotal = calculatedTotal - pairedTotalByIdx[idx];
            const leftoverUnit = Math.round(leftoverTotal / leftoverQty);
            const comboBadge = pairedUnit === 84950
              ? '<span style="display:block;font-size:10px;color:#1e7e34;font-weight:600;margin-top:2px;">COMBO 1699 APPLIED</span>'
              : '';

            if (priceEl) {
              priceEl.innerHTML =
                pairedQty + ' × <s style="opacity:0.5;font-weight:400;margin-right:4px;">' +
                formatMoney(unitOrig) + '</s> ' + formatMoney(pairedUnit) + comboBadge;
            }

            let splitEl = existingSplit;
            if (!splitEl) {
              splitEl = document.createElement('div');
              splitEl.className = 'vrv-cart-line__split-extra';
              rowEl.insertAdjacentElement('afterend', splitEl);
            }
            splitEl.innerHTML =
              '<span class="vrv-cart-line__split-extra-label">' + leftoverQty + ' × not combined</span>' +
              '<span class="vrv-cart-line__split-extra-price">' + formatMoney(leftoverUnit) + '</span>';
          } else {
            if (existingSplit) existingSplit.remove();
            if (priceEl) {
              const displayOrig = item.quantity > 1 ? item.original_line_price : unitOrig;
              const displayFinal = item.quantity > 1 ? calculatedTotal : unitFinal;
              if (hasDiscount) {
                let comboBadge = '';
                if (comboReallyActive && unitFinal === 84950 && !item.title.toUpperCase().includes('COMBO') && !(item.properties && item.properties['VrvComboId'])) {
                   comboBadge = '<span style="display:block;font-size:10px;color:#1e7e34;font-weight:600;margin-top:2px;">COMBO 1699 APPLIED</span>';
                }
                priceEl.innerHTML =
                  '<s style="opacity:0.5;font-weight:400;margin-right:4px;">' +
                  formatMoney(displayOrig) +
                  '</s> ' +
                  formatMoney(displayFinal) + comboBadge;
              } else {
                priceEl.innerHTML = formatMoney(displayOrig);
              }
            }
          }
        });
    });
  }

  const PREFERRED_COUPON_KEY = 'vrvPreferredCoupon';

  function getPreferredCoupon() {
    try {
      return (window.sessionStorage.getItem(PREFERRED_COUPON_KEY) || '').trim().toUpperCase();
    } catch (_) {
      return '';
    }
  }

  function setPreferredCoupon(code) {
    try {
      if (!window.sessionStorage) return;
      if (!code) window.sessionStorage.removeItem(PREFERRED_COUPON_KEY);
      else window.sessionStorage.setItem(PREFERRED_COUPON_KEY, String(code).trim().toUpperCase());
    } catch (_) {}
  }

  const PDP_PENDING_COUPON_KEY = 'vrvPendingPdpCoupon';
  const PDP_OFFER_LOCK_KEY = 'vrvPdpOfferLocksCart';
  let pdpOfferApplyInFlight = false;
  let pdpOfferApplyPromise = null;

  function lockCartForPdpOffer(code) {
    try {
      if (!window.sessionStorage) return;
      window.sessionStorage.setItem(PDP_OFFER_LOCK_KEY, '1');
      if (code) window.sessionStorage.removeItem('vrvAutoApplyBlocked:' + normalizeDiscountCode(code));
    } catch (_) {}
  }

  function parsePdpOfferMeta(options, offerLabel) {
    options = options || {};
    const label = offerLabel || options.offer || '';
    if (options.offerValue != null && options.offerValue !== '') {
      const type = String(options.offerType || 'fixed').toLowerCase();
      const value = Number(options.offerValue) || 0;
      if (type === 'percent') return { type: type, value: value, label: label };
      return { type: 'fixed', value: value, amountCents: Math.round(value * 100), label: label };
    }
    const pct = String(label).match(/(\d+)\s*%/i);
    if (pct) return { type: 'percent', value: Number(pct[1]), label: label };
    const rs =
      String(label)
        .replace(/,/g, '')
        .match(/₹\s*(\d+)/i) || String(label).match(/rs\s*(\d+)/i);
    if (rs) {
      const val = Number(rs[1]) || 0;
      return { type: 'fixed', value: val, amountCents: val * 100, label: label };
    }
    return { type: 'fixed', value: 0, amountCents: 0, label: label };
  }

  function getPdpOfferFromCartAttributes(cart) {
    const attrs = (cart && cart.attributes) || {};
    const code = attrs['PDP Offer Code'];
    if (!code) return null;
    const type = String(attrs['PDP Offer Type'] || 'fixed').toLowerCase();
    const value = Number(attrs['PDP Offer Value'] || 0);
    const amountCents = Number(attrs['PDP Offer Amount'] || 0);
    return {
      code: normalizeDiscountCode(code),
      label: attrs['PDP Offer'] || 'Mobile offer',
      type: type,
      value: value,
      amountCents: amountCents || (type === 'fixed' ? Math.round(value * 100) : 0),
      phone: attrs['Phone (PDP Offer)'] || '',
    };
  }

  function computePdpOfferSavingsCents(cart, meta) {
    if (!meta) return 0;
    if (meta.type === 'percent') {
      const base =
        typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price;
      return Math.round((base * meta.value) / 100);
    }
    return Math.max(0, meta.amountCents || Math.round((meta.value || 0) * 100));
  }

  function getDiscountAllocatedCents(cart, code) {
    const normalized = normalizeDiscountCode(code);
    if (!normalized || !cart) return 0;
    let total = 0;
    const apps = (cart.discount_applications || []).concat(cart.cart_level_discount_applications || []);
    apps.forEach((d) => {
      if (!d || d.target_type === 'shipping_line') return;
      if (codeMatchesDiscountLabel(normalized, d.title || d.code || '')) {
        total += d.total_allocated_amount || 0;
      }
    });
    return total;
  }

  function cartHasPdpDiscountCodeAttached(cart, code) {
    const normalized = normalizeDiscountCode(code);
    if (!normalized || !cart) return false;
    return (cart.discount_codes || []).some(
      (c) => c && c.code && normalizeDiscountCode(c.code) === normalized
    );
  }

  function isPdpDiscountInShopifyCart(cart, meta) {
    if (!meta || !meta.code) return false;
    if (discountEffectivelyActive(cart, meta.code)) return true;
    if (cartHasPdpDiscountCodeAttached(cart, meta.code)) return true;
    return getDiscountAllocatedCents(cart, meta.code) > 0;
  }

  let _vrvPdpCartRepairInFlight = false;

  function maybeRepairOverStackedPdpCart(cartData) {
    if (!cartData || _vrvPdpCartRepairInFlight || isBuyNowCheckoutActive()) return;
    const meta = getPdpOfferFromCartAttributes(cartData);
    const active = getActiveCartDiscountCodes(cartData);
    const vrvCodes = active.filter((c) => c.indexOf('VRV') === 0);

    if (vrvCodes.length > 1) {
      const keep = meta && meta.code ? normalizeDiscountCode(meta.code) : vrvCodes[0];
      const nonVrv = active.filter((c) => c.indexOf('VRV') !== 0);
      _vrvPdpCartRepairInFlight = true;
      applyCombinedCartDiscounts(cartData, nonVrv.concat([keep]), cartData.attributes || {})
        .then((fixed) => {
          if (fixed) syncCartPricingUI(fixed);
        })
        .finally(() => {
          _vrvPdpCartRepairInFlight = false;
        });
      return;
    }

    if (!meta || !meta.code) return;
    if (!cartHasPdpDiscountCodeAttached(cartData, meta.code)) return;

    const original =
      typeof cartData.original_total_price === 'number'
        ? cartData.original_total_price
        : cartData.total_price;
    const pdpExpected = computePdpOfferSavingsCents(cartData, meta);
    const expectedStacked = original - pdpExpected - Math.round(original * 0.3);
    const tolerance = 5000;

    if (cartData.total_price >= expectedStacked - tolerance) return;

    const keepCodes = getActiveCartDiscountCodes(cartData).filter((c) => c !== meta.code);
    if (!keepCodes.length) return;

    _vrvPdpCartRepairInFlight = true;
    applyCombinedCartDiscounts(cartData, [keepCodes[0]], cartData.attributes || {})
      .then((fixed) => {
        if (fixed) syncCartPricingUI(fixed);
      })
      .finally(() => {
        _vrvPdpCartRepairInFlight = false;
      });
  }

  function isPdpOfferApplied(cart, code) {
    const normalized = normalizeDiscountCode(code);
    if (!normalized) return false;
    if (discountEffectivelyActive(cart, normalized)) return true;
    const attr = getPdpOfferFromCartAttributes(cart);
    return Boolean(attr && attr.code === normalized);
  }

  function savePdpOfferCartAttributes(code, meta, phone, existingCart) {
    const attributes = Object.assign({}, (existingCart && existingCart.attributes) || {});
    attributes['PDP Offer'] = meta.label || '';
    attributes['PDP Offer Code'] = normalizeDiscountCode(code);
    attributes['PDP Offer Type'] = meta.type || 'fixed';
    attributes['PDP Offer Value'] = String(meta.value != null ? meta.value : '');
    if (meta.type === 'fixed') {
      attributes['PDP Offer Amount'] = String(
        meta.amountCents != null ? meta.amountCents : Math.round((meta.value || 0) * 100)
      );
    } else {
      attributes['PDP Offer Amount'] = '';
    }
    if (phone) attributes['Phone (PDP Offer)'] = phone;

    return vrvFetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(buildCartUpdateBody({ attributes: attributes })),
    })
      .then((res) => res.json().catch(() => null))
      .catch(() => null);
  }

  function getActiveCartDiscountCodes(cart) {
    if (!cart) return [];
    const fromCodes = (cart.discount_codes || [])
      .filter((c) => c && c.code && c.applicable !== false)
      .map((c) => normalizeDiscountCode(c.code));
    if (fromCodes.length) return fromCodes;

    const apps = (cart.discount_applications || []).concat(cart.cart_level_discount_applications || []);
    const fromApps = [];
    apps.forEach((d) => {
      if (!d || d.target_type === 'shipping_line') return;
      if (d.type !== 'discount_code' && d.type !== 'code') return;
      const normalized = normalizeDiscountCode(d.title || d.code || '');
      if (normalized && !fromApps.includes(normalized)) fromApps.push(normalized);
    });
    return fromApps;
  }

  function buildPdpOfferAttributeMap(meta, cart, phone) {
    return Object.assign({}, (cart && cart.attributes) || {}, {
      'PDP Offer': (meta && meta.label) || '',
      'PDP Offer Code': (meta && meta.code) || '',
      'PDP Offer Type': (meta && meta.type) || 'fixed',
      'PDP Offer Value': String(meta && meta.value != null ? meta.value : ''),
      'PDP Offer Amount': String((meta && meta.amountCents) || ''),
      'Phone (PDP Offer)':
        phone || (cart && cart.attributes && cart.attributes['Phone (PDP Offer)']) || '',
      'PDP Offer Stacked': '1',
    });
  }

  function normalizeCombinedDiscountCodes(cart, codes) {
    const meta = getPdpOfferFromCartAttributes(cart);
    const canonicalPdp = meta && meta.code ? normalizeDiscountCode(meta.code) : '';
    const unique = [];
    let pdpKept = false;

    (codes || []).forEach((code) => {
      const normalized = normalizeDiscountCode(code);
      if (!normalized || unique.includes(normalized)) return;
      const isPdpVrv = normalized.indexOf('VRV') === 0;
      if (isPdpVrv) {
        if (canonicalPdp && normalized !== canonicalPdp) return;
        if (pdpKept) return;
        pdpKept = true;
      }
      unique.push(normalized);
    });

    if (canonicalPdp && !unique.includes(canonicalPdp)) {
      const nonPdp = unique.filter((c) => c.indexOf('VRV') !== 0);
      return nonPdp.concat([canonicalPdp]);
    }

    return unique;
  }

  function applyCombinedCartDiscounts(cart, codes, attributes) {
    const unique = normalizeCombinedDiscountCodes(cart, codes);
    if (!unique.length) return Promise.resolve(cart);

    const bodyFields = { discount: unique.join(',') };
    if (attributes) bodyFields.attributes = attributes;

    return vrvFetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(buildCartUpdateBody(bodyFields)),
    })
      .then((res) => res.json().catch(() => null))
      .catch(() => null);
  }

  function preparePdpStackedCheckout(cart) {
    const activeLabels = []
      .concat((cart && cart.discount_codes) || [])
      .concat((cart && cart.discount_applications) || [])
      .concat((cart && cart.cart_level_discount_applications) || [])
      .map((discount) => normalizeDiscountCode(discount && (discount.code || discount.title || '')));
    const comboIsAuthoritative = activeLabels.some((label) =>
      label.includes('VRVCMBO') ||
      (label.includes('BUY 2 AT') && label.includes('1699')) ||
      (label.includes('COMBO') && label.includes('1699'))
    );
    // The 1699 combo is exclusive. A stale PDP-offer cart attribute must not
    // replace it after Gift Wrap preparation and immediately before Razorpay.
    if (comboIsAuthoritative) return Promise.resolve(cart);

    const meta = getPdpOfferFromCartAttributes(cart);
    if (!meta || !meta.code) return Promise.resolve(cart);
    if (discountEffectivelyActive(cart, meta.code)) return Promise.resolve(cart);

    const existing = getActiveCartDiscountCodes(cart).filter(
      (c) => c !== meta.code && c.indexOf('VRV') !== 0
    );
    const combined = existing.length ? existing.concat([meta.code]) : [meta.code];
    const attributes = buildPdpOfferAttributeMap(meta, cart);

    function attempt(triesLeft) {
      return applyCombinedCartDiscounts(cart, combined, attributes).then((updated) => {
        const next = (updated && typeof updated.item_count === 'number') ? updated : cart;
        if (discountEffectivelyActive(next, meta.code)) return next;
        if (triesLeft <= 0) return next;
        return new Promise((resolve) => setTimeout(resolve, 450)).then(() => attempt(triesLeft - 1));
      });
    }

    return attempt(2);
  }

  function isPdpOfferCartLocked() {
    try {
      return window.sessionStorage && window.sessionStorage.getItem(PDP_OFFER_LOCK_KEY) === '1';
    } catch (_) {
      return false;
    }
  }

  function hasPdpOfferPriority() {
    const pending = getPendingPdpCoupon();
    if (pending && pending.code) return true;
    const preferred = getPreferredCoupon();
    return Boolean(preferred && preferred.indexOf('VRV') === 0);
  }

  function savePendingPdpCoupon(code, phone, options) {
    options = options || {};
    try {
      if (!window.sessionStorage || !code) return;
      window.sessionStorage.setItem(
        PDP_PENDING_COUPON_KEY,
        JSON.stringify({
          code: normalizeDiscountCode(code),
          phone: phone || '',
          offer: options.offer || '',
          offerType: options.offerType || '',
          offerValue: options.offerValue != null ? options.offerValue : '',
          ts: Date.now(),
        })
      );
    } catch (_) {}
  }

  function getPendingPdpCoupon() {
    try {
      const raw = window.sessionStorage.getItem(PDP_PENDING_COUPON_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || !data.code) return null;
      if (data.ts && Date.now() - data.ts > 72 * 60 * 60 * 1000) {
        window.sessionStorage.removeItem(PDP_PENDING_COUPON_KEY);
        return null;
      }
      return data;
    } catch (_) {
      return null;
    }
  }

  function clearPendingPdpCoupon() {
    try {
      if (window.sessionStorage) window.sessionStorage.removeItem(PDP_PENDING_COUPON_KEY);
    } catch (_) {}
  }

  function explainDiscountApplyFailure(cart, code) {
    const needle = normalizeDiscountCode(code);
    if (!needle) return 'Could not apply this offer. Please try again.';

    const entry = (cart && cart.discount_codes || []).find(
      (c) => c && c.code && normalizeDiscountCode(c.code) === needle
    );

    if (entry && entry.applicable === false) {
      return 'Offer code is not active yet — wait 5 seconds and tap Apply again.';
    }

    return 'Could not apply this offer. Please tap Apply again.';
  }

  function finishPdpOfferApply(applied, cart, normalized) {
    pdpOfferApplyInFlight = false;
    if (applied) {
      clearPendingPdpCoupon();
      window.vrvLastCouponApplyError = '';
    } else {
      window.vrvLastCouponApplyError = explainDiscountApplyFailure(cart, normalized);
    }
    return applied;
  }

  function publishPdpOfferCartUpdate(cart) {
    if (!cart) return;
    syncCartPricingUI(cart);
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: Object.assign({}, cart, { source: 'pdp-offer' }),
      })
    );
  }

  /** PDP mobile offer — stacks with NEW30 via cart attributes; does not replace existing coupons. */
  function applyPdpOfferCode(code, options) {
    options = options || {};
    const normalized = normalizeDiscountCode(code);
    if (!normalized) return Promise.resolve(false);

    if (pdpOfferApplyPromise) return pdpOfferApplyPromise;

    const meta = parsePdpOfferMeta(options, options.offer || options.offerLabel || '');
    savePendingPdpCoupon(normalized, options.phone || '', options);
    lockCartForPdpOffer(normalized);
    pdpOfferApplyInFlight = true;

    const noopRestore = () => {};

    function finish(applied, cart) {
      return finishPdpOfferApply(applied, cart, normalized);
    }

    function succeedWithCart(cart) {
      publishPdpOfferCartUpdate(cart);
      return finish(true, cart);
    }

    function attemptDiscountApply(tryNum, cartAfterAttrs) {
      const applyCode = mapCouponForGiftWrapCart(normalized, cartAfterAttrs) || normalized;
      return vrvFetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildCartUpdateBody({ discount: applyCode })),
      })
        .then((res) =>
          res.json().then((data) => ({
            data: data,
            ok: res.ok,
            applyCode: applyCode,
          }))
        )
        .then((result) => {
          const { data, ok, applyCode: effectiveCode } = result;
          const effective = effectiveCode || normalized;

          if (ok && data && discountEffectivelyActive(data, effective)) {
            writeActiveCouponAttribute(normalized);
            return finishSuccessfulDiscountApply(data, normalized, null, noopRestore).then(() => succeedWithCart(data));
          }

          // FIX (root cause of "voucher code generated but an error is shown
          // when applying it" / retry loop below timing out): if a combo is
          // active, the code just applied above gets folded into a fresh
          // VRVCMBO_<amount>_<hash> composite code by the background combo
          // sync (assets/vrv-combo-1699.js) within ~1s -- so the very next
          // fresh-cart check below was racing that background job and
          // usually losing, burning through all 6 retries never seeing a
          // code literally named `normalized`. Let the combo engine settle
          // first so the fresh cart fetched next already reflects the final,
          // correctly-folded state instead of a stale intermediate one.
          const comboSettled =
            typeof window.vrvEnsureComboSynced === 'function'
              ? window.vrvEnsureComboSynced().catch(() => null)
              : Promise.resolve();

          return comboSettled.then(() => fetchFreshCart()).then((fresh) => {
            const latest = fresh || data || cartAfterAttrs;
            if (latest && discountEffectivelyActive(latest, effective)) {
              writeActiveCouponAttribute(normalized);
              return finishSuccessfulDiscountApply(latest, normalized, null, noopRestore).then(() =>
                succeedWithCart(latest)
              );
            }
            if (isPdpOfferApplied(latest, normalized)) {
              return succeedWithCart(latest);
            }

            if (tryNum < 6) {
              return new Promise((resolve) => setTimeout(resolve, 500 + tryNum * 350)).then(() =>
                attemptDiscountApply(tryNum + 1, latest)
              );
            }

            return finish(false, latest);
          });
        });
    }

    pdpOfferApplyPromise = fetchFreshCart()
      .then((cart) => {
        if (isPdpOfferApplied(cart, normalized)) {
          publishPdpOfferCartUpdate(cart);
          return finish(true, cart);
        }

        return savePdpOfferCartAttributes(normalized, meta, options.phone || '', cart)
          .then((updated) => updated || cart)
          .then((cartAfterAttrs) => {
            if (isPdpOfferApplied(cartAfterAttrs, normalized)) {
              return succeedWithCart(cartAfterAttrs);
            }

            const otherCodeActive =
              cartHasAttachedDiscountCode(cartAfterAttrs) &&
              !discountEffectivelyActive(cartAfterAttrs, normalized);

            if (otherCodeActive) {
              return succeedWithCart(cartAfterAttrs);
            }

            if (!cartHasAttachedDiscountCode(cartAfterAttrs)) {
              return attemptDiscountApply(0, cartAfterAttrs);
            }

            if (cartHasAutomaticDiscount(cartAfterAttrs)) {
              return attemptDiscountApply(0, cartAfterAttrs);
            }

            return succeedWithCart(cartAfterAttrs);
          });
      })
      .catch(() => finish(false, null))
      .finally(() => {
        pdpOfferApplyPromise = null;
        pdpOfferApplyInFlight = false;
      });

    return pdpOfferApplyPromise;
  }

  /** Re-apply a saved PDP offer when the cart gains items after unlock. */
  function tryApplyPendingPdpCoupon() {
    if (pdpOfferApplyInFlight || autoApplyInFlight) return;
    if (isBuyNowCheckoutActive()) return;
    if (Date.now() < couponApplyCooldownUntil) return;

    const pending = getPendingPdpCoupon();
    if (!pending || !pending.code) return;

    fetchFreshCart().then((cart) => {
      if (!cart || !Number(cart.item_count)) return;
      if (isPdpOfferApplied(cart, pending.code)) {
        clearPendingPdpCoupon();
        syncCartPricingUI(cart);
        return;
      }
      applyPdpOfferCode(pending.code, {
        phone: pending.phone,
        offer: pending.offer || '',
        offerType: pending.offerType || '',
        offerValue: pending.offerValue != null ? pending.offerValue : '',
      });
    });
  }

  function formatCartMoney(cents) {
    if (typeof cents !== 'number') return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /**
   * Sync totals with Shopify cart state. When the customer removed a coupon we
   * hide discount rows and show catalogue prices. Otherwise trust cart.total_price.
   */
  function syncCartPricingUI(cartData) {
    if (!cartData) return;
    if (isBuyNowCheckoutActive()) return;

    // Guard against stale cartData payload overwriting a newer live DOM state
    const liveLines = document.querySelectorAll('cart-drawer .vrv-cart-line, #VrvCartPage .vrv-cart-line');
    if (liveLines.length > 0 && Array.isArray(cartData.items)) {
      let liveTotalQty = 0;
      liveLines.forEach((line) => {
        const qtyInput = line.querySelector('input.quantity__input, input[name="updates[]"]');
        if (qtyInput) {
          liveTotalQty += parseInt(qtyInput.value, 10) || 1;
        } else {
          liveTotalQty += 1;
        }
      });
      let cartDataTotalQty = 0;
      cartData.items.forEach((it) => {
        cartDataTotalQty += Number(it.quantity) || 0;
      });
      if (liveTotalQty > 0 && cartDataTotalQty > 0 && liveTotalQty > cartDataTotalQty) {
        console.warn('[VRV PRICING] Stale cartData payload rejected: DOM total qty ' + liveTotalQty + ' > cart qty ' + cartDataTotalQty);
        setTimeout(() => {
          fetchFreshCart({ bustCache: true }).then((fresh) => {
            if (fresh) syncCartPricingUI(fresh);
          });
        }, 150);
        return;
      }
    }

    document.querySelectorAll('[data-vrv-coupon-preview], .vrv-cart-totals__row--preview').forEach((el) => {
      el.hidden = true;
      el.style.display = 'none';
    });

    const formatMoney = formatCartMoney;
    const original =
      typeof cartData.original_total_price === 'number' ? cartData.original_total_price : cartData.total_price;
    const shopifyTotal =
      typeof cartData.total_price === 'number' ? cartData.total_price : original;
    const hasActiveDiscount = cartHasUndismissedDiscount(cartData);
    const showDiscount = hasActiveDiscount;
    const giftWrapRestore =
      window.vrvGiftWrapHelpers &&
      typeof window.vrvGiftWrapHelpers.getGiftWrapDiscountRestoreCents === 'function'
        ? window.vrvGiftWrapHelpers.getGiftWrapDiscountRestoreCents(cartData)
        : 0;
    const shopifyReduction = showDiscount ? Math.max(0, original - shopifyTotal - giftWrapRestore) : 0;
    const pdpMeta = getPdpOfferFromCartAttributes(cartData);
    let couponSavings = shopifyReduction;
    let pdpSavings = 0;

    // Never invent a temporary combo total in the browser. The Shopify cart
    // returned after the serialized combo sync is the sole pricing source for
    // the drawer, cart page, checkout payload, and Razorpay.
    const isOptimisticDiscount = false;

    if (pdpMeta && pdpMeta.code) {
      const pdpExpected = computePdpOfferSavingsCents(cartData, pdpMeta);
      const pdpInShopify = isPdpDiscountInShopifyCart(cartData, pdpMeta);

      if (pdpInShopify) {
        pdpSavings = getDiscountAllocatedCents(cartData, pdpMeta.code) || pdpExpected;
        couponSavings = Math.max(0, shopifyReduction - pdpSavings);
      } else if (pdpExpected > 0) {
        pdpSavings = pdpExpected;
        if (showDiscount && shopifyReduction >= pdpSavings) {
          couponSavings = Math.max(0, shopifyReduction - pdpSavings);
        }
      }
    }

    const hasPdpStack = pdpSavings > 0;
    const totalSavings = (showDiscount || isOptimisticDiscount ? couponSavings : 0) + pdpSavings;
    let displayTotal = totalSavings > 0 ? Math.max(0, original - totalSavings) : original;
    let showBreakdown = ((showDiscount || isOptimisticDiscount) && couponSavings > 0) || hasPdpStack;

    maybeRepairOverStackedPdpCart(cartData);

    document.querySelectorAll('cart-drawer .vrv-cart-totals, #VrvCartPage .vrv-cart-totals').forEach((root) => {
      const subRow = root.querySelector('.vrv-cart-totals__row--sub');
      const discountRow = root.querySelector('.vrv-cart-totals__row--inline-discount');
      let pdpRow = root.querySelector('.vrv-cart-totals__row--pdp-offer');
      const finalEl = root.querySelector('.vrv-cart-totals__value--final');
      const savingsEl = root.querySelector('.vrv-cart-totals__savings');

      if (hasPdpStack) {
        if (!pdpRow) {
          pdpRow = document.createElement('div');
          pdpRow.className = 'vrv-cart-totals__row vrv-cart-totals__row--pdp-offer vrv-cart-totals__row--inline-discount';
          pdpRow.innerHTML =
            '<span class="vrv-cart-totals__label"></span>' +
            '<span class="vrv-cart-totals__value vrv-cart-totals__value--negative"></span>';
          const finalRow = root.querySelector('.vrv-cart-totals__row--final');
          if (finalRow) finalRow.insertAdjacentElement('beforebegin', pdpRow);
          else root.appendChild(pdpRow);
        }
        pdpRow.hidden = false;
        pdpRow.style.display = '';
        const pdpLabel = pdpRow.querySelector('.vrv-cart-totals__label');
        const pdpValue = pdpRow.querySelector('.vrv-cart-totals__value--negative');
        if (pdpLabel) pdpLabel.textContent = pdpMeta.label || 'Mobile offer';
        if (pdpValue) pdpValue.textContent = '−' + formatMoney(pdpSavings);
      } else if (pdpRow) {
        pdpRow.hidden = true;
        pdpRow.style.display = 'none';
      }

      if (showBreakdown) {
        if (subRow && (showDiscount || isOptimisticDiscount || hasPdpStack)) {
          subRow.hidden = false;
          subRow.style.display = '';
          const subVal = subRow.querySelector('.vrv-cart-totals__value');
          if (subVal) subVal.textContent = formatMoney(original);
        }
        if (discountRow && (showDiscount || isOptimisticDiscount) && couponSavings > 0) {
          discountRow.hidden = false;
          discountRow.style.display = '';
          const neg = discountRow.querySelector('.vrv-cart-totals__value--negative');
          if (neg) neg.textContent = '−' + formatMoney(couponSavings);
        } else if (discountRow) {
          discountRow.hidden = true;
          discountRow.style.display = 'none';
        }
        if (finalEl) finalEl.textContent = formatMoney(displayTotal);
        if (savingsEl && totalSavings > 0) {
          savingsEl.hidden = false;
          savingsEl.style.display = '';
          savingsEl.innerHTML =
            '<span class="vrv-cart-totals__savings-icon" aria-hidden="true">✓</span> You save '
            + formatMoney(totalSavings)
            + ' on this order';
        } else if (savingsEl) {
          savingsEl.hidden = true;
          savingsEl.style.display = 'none';
        }
      } else {
        [subRow, discountRow, savingsEl].forEach((el) => {
          if (el) {
            el.hidden = true;
            el.style.display = 'none';
          }
        });
        if (finalEl) finalEl.textContent = formatMoney(original);
      }
    });

    document
      .querySelectorAll('.vrv-drawer__coupon-applied-savings strong, .vrv-page-offers__applied-savings strong')
      .forEach((el) => {
        if (showBreakdown && couponSavings > 0) el.textContent = '−' + formatMoney(couponSavings);
      });



    syncCartLinePrices(cartData, formatMoney, showBreakdown);
  }

  function syncCartDisplayWithoutCoupon(cartData) {
    syncCartPricingUI(cartData);
  }

  window.vrvSyncCartDisplayWithoutCoupon = syncCartDisplayWithoutCoupon;
  window.vrvSyncCartPricingUI = syncCartPricingUI;
  window.vrvClearAllDismissedDiscounts = clearAllDismissedDiscounts;
  window.vrvApplyDiscount = applyDiscount;
  window.vrvApplyPdpOfferCode = applyPdpOfferCode;
  window.vrvIsPdpOfferApplied = isPdpOfferApplied;
  window.vrvGetPdpOfferFromCart = getPdpOfferFromCartAttributes;

  function hideDismissedDiscountCards(scope) {
    const dismissed = getDismissedDiscounts();
    if (dismissed.size === 0) return;
    const root = scope || document;

    root.querySelectorAll('.vrv-drawer__coupon-toolbar').forEach((toolbar) => {
      if (toolbar.dataset.vrvHidden === '1') return;
      const codeEl = toolbar.querySelector('.vrv-drawer__coupon-applied-code');
      if (!codeEl) return;
      const codes = (codeEl.textContent || '')
        .split(',')
        .map((c) => c.trim().toUpperCase())
        .filter(Boolean);
      if (codes.length === 0) return;
      const allDismissed = codes.every((c) => dismissed.has(c));
      if (!allDismissed) return;

      toolbar.dataset.vrvHidden = '1';
      toolbar.style.display = 'none';

      const offersRoot = toolbar.closest('[data-vrv-cart-offers]') || toolbar.parentElement;
      if (offersRoot && !offersRoot.querySelector('[data-vrv-dismissed-input]')) {
        const input = document.createElement('div');
        input.setAttribute('data-vrv-dismissed-input', '1');
        input.className = 'vrv-drawer__coupon-entry';
        input.innerHTML = drawerCouponInputRowHtml();
        toolbar.insertAdjacentElement('afterend', input);
      } else if (offersRoot) {
        ensureDrawerViewAllOffersButton(offersRoot);
      }
    });

    fetchFreshCart().then((cart) => {
      if (cart) syncCartPricingUI(cart);
    });
  }

  function removeDiscount(evt) {
    if (window.vrvSetCheckoutLoading) window.vrvSetCheckoutLoading(true);
    const btn = evt && evt.currentTarget;
    if (btn) {
      btn.dataset.vrvOriginalLabel = btn.textContent.trim();
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = 'Removing…';
    }

    const restoreBtn = () => {
      if (window.vrvSetCheckoutLoading) window.vrvSetCheckoutLoading(false);
      if (!btn) return;
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (btn.dataset.vrvOriginalLabel) {
        btn.textContent = btn.dataset.vrvOriginalLabel;
        delete btn.dataset.vrvOriginalLabel;
      }
    };

    if (btn) {
      const card = btn.closest('.vrv-drawer__coupon-applied, .vrv-page-offers__applied');
      if (card) card.style.opacity = '0.55';
    }

    couponApplyCooldownUntil = Date.now() + 8000;
    setPreferredCoupon('');
    writeActiveCouponAttribute('');

    return fetchFreshCart()
      .then((cartBefore) => {
        getDisplayedAppliedCodes(btn).forEach((c) => {
          blockAutoApplyForCode(c);
          addDismissedDiscount(c);
        });
        dismissAllDiscountsOnCart(cartBefore);
        return clearCartDiscountCodes();
      })
      .then((data) => fetchFreshCart().then((fresh) => fresh || data))
      .then((data) => {
        return refreshCartAfterCouponChange(data, { skipAutoApply: true }).then(() => {
          const codesGone = !cartHasAttachedDiscountCode(data);
          const discountGone = !cartHasActiveDiscount(data);
          const drawer = getCartDrawer();

          if (codesGone) {
            hideDismissedDiscountCards(drawer || document);
          }

          syncCartPricingUI(data);

          return fetchFreshCart()
            .then((fresh) => {
              if (fresh) syncCartPricingUI(fresh);
            })
            .then(() => {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-coupon-remove', cartData: data });
              }
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: Object.assign({}, data, { source: 'cart-coupon-remove' }),
                })
              );
              restoreBtn();
            });
        });
      })
      .catch(() => {
        showCouponError('Could not remove the coupon. Please try again.', btn);
        restoreBtn();
      });
  }

  let _vrvLastPricingSyncAt = 0;

  function afterBindExtrasSyncPricing(passedCart) {
    if (isBuyNowCheckoutActive()) return;
    if (passedCart && typeof passedCart === 'object' && Array.isArray(passedCart.items)) {
      _vrvLastPricingSyncAt = Date.now();
      syncCartPricingUI(passedCart);
      return;
    }
    const now = Date.now();
    if (now - _vrvLastPricingSyncAt < 800) return;
    _vrvLastPricingSyncAt = now;
    fetchFreshCart().then((cart) => {
      if (cart) syncCartPricingUI(cart);
    });
  }

  function handleRecAdd(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    if (typeof window.vrvAddToCart === 'function') {
      window.vrvAddToCart(variantId, btn, 'vrv-rec-card');
    }
  }

  /**
   * Cart drawer "Add a Gift Box" card. Goes through
   * window.vrvGiftWrapCart.addGiftWrapOnly() (assets/vrv-gift-wrap.js)
   * instead of the generic window.vrvAddToCart used above, because the gift
   * line must carry the VrvGiftWrap property -- that's what gives it the
   * quantity-1 lock (see the vrv_is_gift_wrap_line check in
   * snippets/vrv-cart-drawer-line.liquid) and keeps it excluded from coupon
   * discounts, exactly like the PDP gift-wrap checkbox.
   */
  function handleGiftAdd(btn) {
    if (!btn || btn.disabled) return;
    if (!window.vrvGiftWrapCart || typeof window.vrvGiftWrapCart.addGiftWrapOnly !== 'function') return;

    const variantId = btn.dataset.variantId;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    window.vrvGiftWrapCart
      .addGiftWrapOnly({ giftVariantId: variantId, cartEl: getCartDrawer() })
      .then(() => {
        btn.textContent = 'Added';
        invalidateCartJsCache();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'gift-add' } }));
        const drawer = getCartDrawer();
        if (drawer && typeof drawer.refreshDrawer === 'function') {
          return drawer.refreshDrawer(true);
        }
      })
      .catch((err) => {
        console.warn('[VRV gift add]', err);
        window.alert((err && err.message) || 'Could not add gift to cart. Please try again.');
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function readWishlistFromStorage() {
    try {
      const raw = JSON.parse(localStorage.getItem('wishlist') || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (_) {
      return [];
    }
  }

  function saveWishlistToStorage(items) {
    try {
      localStorage.setItem('wishlist', JSON.stringify(items));
    } catch (_) {}
  }

  function addToWishlistFromCartButton(btn) {
    const handle = btn?.dataset?.productHandle;
    if (!handle) return false;

    const line = btn.closest('.cart-item, .vrv-cart-line');
    const qtyInput = line && line.querySelector('.quantity__input[data-quantity-variant-id]');
    const variantId = qtyInput ? qtyInput.getAttribute('data-quantity-variant-id') : '';
    const title = btn?.dataset?.productTitle || '';
    const url = btn?.dataset?.productUrl || '';

    const wishlist = readWishlistFromStorage();
    const exists = wishlist.some((item) => item && item.handle === handle);
    if (!exists) {
      wishlist.push({ handle, variantId, title, url });
      saveWishlistToStorage(wishlist);
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }
    return true;
  }

  function removeCartLineForSaveLater(btn) {
    const line = btn.closest('.cart-item, .vrv-cart-line');
    if (!line) return false;

    const qtyInput = line.querySelector('.quantity__input[data-index]');
    const lineIndex = qtyInput && qtyInput.dataset ? qtyInput.dataset.index : null;
    const cartItems = line.closest('cart-items') || line.closest('cart-drawer-items');
    if (!lineIndex || !cartItems || typeof cartItems.updateQuantity !== 'function') return false;

    cartItems.updateQuantity(lineIndex, 0);
    return true;
  }

  function handleSaveForLater(btn) {
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    const oldLabel = btn.textContent;
    btn.textContent = 'Saving...';

    const saved = addToWishlistFromCartButton(btn);
    const removed = removeCartLineForSaveLater(btn);

    if (saved && removed) {
      btn.classList.add('is-saved');
      return;
    }

    btn.disabled = false;
    btn.textContent = oldLabel || 'Save for later';
  }

  /**
   * Auto-apply eligible coupon — triggers /cart/update.js with the discount code
   * for the single offer card marked with data-vrv-auto-apply="1".
   *
   * Guards:
   *  - Skips if the code was already attempted this session (avoids loop on failure)
   *  - Skips if any auto-apply card is already in a "Auto-Applied" visual state
   *  - Skips while a cart fetch is in flight
   */
  let autoApplyInFlight = false;
  function autoApplyEligibleDiscount(scope) {
    // Disabled: Do not auto-apply discount vouchers on page load/refresh without user action.
    return;
  }

  /** Clear auto-apply session flag if cart total drops below the offer's minimum
   *  (so the coupon can re-apply if user reaches the threshold again). */
  function clearAutoApplyFlagsOnRefresh(scope) {
    try {
      if (!window.sessionStorage) return;
      const root = scope || document;
      const allCards = root.querySelectorAll('[data-vrv-offer-card]');
      const eligibleAutoCodes = new Set();
      allCards.forEach((c) => {
        if (c.getAttribute('data-vrv-auto-apply') === '1') {
          const code = c.getAttribute('data-vrv-offer-code');
          if (code) eligibleAutoCodes.add(code);
        }
      });
      Object.keys(window.sessionStorage).forEach((key) => {
        if (key.indexOf('vrvAutoApply:') !== 0) return;
        const code = key.substring('vrvAutoApply:'.length);
        if (!eligibleAutoCodes.has(code)) {
          window.sessionStorage.removeItem(key);
        }
      });
    } catch (_) {}
  }

  function initDrawerEventDelegation() {
    const drawer = getCartDrawer();
    if (!drawer || drawer.dataset.vrvDrawerDelegation === '1') return;
    drawer.dataset.vrvDrawerDelegation = '1';

    drawer.addEventListener(
      'click',
      (event) => {
        const applyInputBtn = event.target.closest('[data-vrv-apply-discount-input]');
        if (applyInputBtn && drawer.contains(applyInputBtn)) {
          event.preventDefault();
          event.stopPropagation();
          const input = getCouponInputEl();
          applyDiscount(input ? input.value : '', applyInputBtn);
          return;
        }

        const applyBtn = event.target.closest('[data-vrv-apply-discount]');
        if (applyBtn && drawer.contains(applyBtn)) {
          event.preventDefault();
          event.stopPropagation();
          applyDiscount(applyBtn.dataset.vrvApplyDiscount, applyBtn);
          return;
        }

        const couponsBtn = event.target.closest('[data-vrv-open-coupons-page]');
        if (couponsBtn && drawer.contains(couponsBtn)) {
          event.preventDefault();
          event.stopPropagation();
          openCouponsPage();
          return;
        }

        const removeBtn = event.target.closest('[data-vrv-remove-discount]');
        if (removeBtn && drawer.contains(removeBtn)) {
          event.preventDefault();
          event.stopPropagation();
          removeDiscount({ currentTarget: removeBtn });
          return;
        }

        const recAddBtn = event.target.closest('.vrv-rec-card__add');
        if (recAddBtn && drawer.contains(recAddBtn)) {
          event.preventDefault();
          event.stopPropagation();
          handleRecAdd(recAddBtn);
          return;
        }
      },
      true
    );
  }

  window.vrvDrawerRemoveDiscount = removeDiscount;

  function bindExtras(root, options) {
    const opts = options || {};
    const scope = root || document;

    if (scope.tagName === 'CART-DRAWER' || scope.closest?.('cart-drawer')) {
      ensureDrawerCheckoutBar();
    }

    scope.querySelectorAll('[data-vrv-offers-toggle]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', () => {
        const panel = document.getElementById('CartDrawer-OffersPanel');
        if (!panel) return;
        const open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    scope.querySelectorAll('[data-vrv-open-coupons-page]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', () => openCouponsPage());
    });

    scope.querySelectorAll('[data-vrv-coupons-back]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', () => closeCouponsPage());
    });

    scope.querySelectorAll('[data-vrv-apply-discount]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyDiscount(btn.dataset.vrvApplyDiscount, btn);
      });
    });

    scope.querySelectorAll('[data-vrv-copy-discount]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        copyDiscountCode(btn.dataset.vrvCopyDiscount, btn);
      });
    });

    if (!opts.skipAutoApply) {
      clearAutoApplyFlagsOnRefresh(scope);
      autoApplyEligibleDiscount(scope);
    }

    hideDismissedDiscountCards(scope);
    document.querySelectorAll('cart-drawer [data-vrv-cart-offers]').forEach((offersRoot) => {
      ensureDrawerViewAllOffersButton(offersRoot);
    });
    afterBindExtrasSyncPricing(opts.cart);

    scope.querySelectorAll('[data-vrv-apply-discount-input]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', () => {
        const input = getCouponInputEl();
        applyDiscount(input ? input.value : '', btn);
      });
    });

    scope.querySelectorAll('#CartPage-CouponInput, #CartDrawer-CouponInput').forEach((couponInput) => {
      if (couponInput.dataset.vrvBound) return;
      couponInput.dataset.vrvBound = 'true';
      couponInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const applyBtn = couponInput
            .closest('.vrv-drawer__coupon-input-row, .vrv-cart-page__promo-input-wrap')
            ?.querySelector('[data-vrv-apply-discount-input]');
          applyDiscount(couponInput.value, applyBtn);
        }
      });
    });

    scope.querySelectorAll('[data-vrv-remove-discount]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', removeDiscount);
    });

    scope.querySelectorAll('.vrv-rec-card__add').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', () => handleRecAdd(btn));
    });

    scope.querySelectorAll('[data-vrv-gift-add]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', () => handleGiftAdd(btn));
    });

    scope.querySelectorAll('[data-vrv-save-later]').forEach((btn) => {
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSaveForLater(btn);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDrawerEventDelegation();
    const drawer = getCartDrawer();
    if (drawer) bindExtras(drawer);
    setTimeout(tryApplyPendingPdpCoupon, 600);
  });

  let qtyUpdateCooldownUntil = 0;
  let couponApplyCooldownUntil = 0;

  function scheduleBindExtrasAfterCartChange(options) {
    setTimeout(() => {
      if (document.getElementById('main-cart-items')?.classList.contains('cart__items--disabled')) return;
      const cartPage = document.getElementById('VrvCartPage');
      const drawer = getCartDrawer();
      if (cartPage) bindExtras(cartPage, options);
      if (drawer) bindExtras(drawer, options);
    }, 0);
  }

  document.addEventListener('cart:line-updated', () => {
    qtyUpdateCooldownUntil = Date.now() + 2500;
    scheduleBindExtrasAfterCartChange({ skipAutoApply: true });
    // Any cart line change while Razorpay is closed means the user is in normal
    // cart mode — unconditionally clear ALL Buy Now session keys so neither the
    // MutationObserver path nor the page-reload restore path can re-add items
    // the user just intentionally removed.
    const rzpOpen =
      document.querySelector('.razorpay-container') ||
      document.querySelector('.razorpay-checkout-frame') ||
      document.querySelector('iframe.razorpay-checkout-frame');
    if (!rzpOpen && !(_vrvBuyNowActiveThisLoad && isBuyNowCheckoutActive())) {
      // Discarding a saved cart here would lose the shopper's real items;
      // bring them back first (no-op when there is nothing saved).
      if (readBuyNowSnapshot()) {
        window.vrvRestoreCartSnapshotAfterBuyNow({ silent: true });
      } else {
        clearBuyNowSessionKeys();
      }
    }
  });

  document.addEventListener('cart:updated', (e) => {
    const detail = e && e.detail;
    const source = detail && detail.source;
    if (detail && typeof detail.item_count === 'number') {
      updateCartIconBubble(detail);
      if (detail.item_count === 0) {
        const drawer = getCartDrawer();
        if (drawer) {
          drawer.classList.add('is-empty');
          drawer.classList.remove('is-coupons-open');
          const couponsPage = document.getElementById('CartDrawer-CouponsPage');
          if (couponsPage) {
            couponsPage.classList.remove('is-open');
            couponsPage.setAttribute('hidden', '');
            couponsPage.setAttribute('aria-hidden', 'true');
          }
        }
      }
    }
    if (source === 'line-items') return;
    const passiveRefresh = source === 'refreshDrawer' || source === 'vrv-partial-refresh';
    if (!passiveRefresh) {
      scheduleGiftWrapDiscountIntegrity();
    }
    const skipAuto =
      source === 'cart-coupon' ||
      source === 'cart-coupon-remove' ||
      source === 'pdp-offer' ||
      Date.now() < couponApplyCooldownUntil;
    scheduleBindExtrasAfterCartChange({ skipAutoApply: skipAuto });
    if (source !== 'pdp-offer' && source !== 'cart-coupon' && !passiveRefresh) {
      setTimeout(tryApplyPendingPdpCoupon, 400);
    }
  });

  /**
   * Auto-cleanup stale discount codes.
   *
   * Shopify keeps a discount code "attached" to the cart even after the cart
   * drops below the code's minimum cart value. In that state the code still
   * appears in `cart.discount_applications` with `total_allocated_amount = 0`,
   * which used to make the View All Offers panel show a stale "Applied" badge.
   *
   * We now skip 0-allocation entries in Liquid, but we also proactively detach
   * those codes from the cart so the next /cart.js call returns a clean state
   * (no ghost codes). When the customer adds items back above the threshold
   * they can re-apply the code fresh — matching the smooth Razorpay/Palmonas
   * flow the user expects.
   */
  let cartCleanupInFlight = false;
  let cartCleanupCooldownUntil = 0;
  function cleanupStaleDiscounts(detail) {
    if (cartCleanupInFlight) return;
    if (Date.now() < cartCleanupCooldownUntil) return;
    if (Date.now() < couponApplyCooldownUntil) return;
    if (detail && (detail.source === 'cart-coupon' || detail.source === 'cart-coupon-remove')) return;

    const inspect = (data) => {
      if (!data || !Array.isArray(data.discount_applications)) return;

      const codeApps = data.discount_applications.filter(isCartDiscountCode);
      if (codeApps.length === 0) return;

      const staleCodeApps = codeApps.filter((d) => !d.total_allocated_amount || d.total_allocated_amount <= 0);
      if (staleCodeApps.length === 0) return;

      cartCleanupInFlight = true;
      cartCleanupCooldownUntil = Date.now() + 4000;

      const activeCodes = codeApps
        .filter((d) => d.total_allocated_amount > 0 && d.title)
        .map((d) => d.title);

      const body = new URLSearchParams();
      body.append('discount', activeCodes.length > 0 ? activeCodes.join(',') : '');

      fetch(`${(window.routes && window.routes.cart_update_url) || '/cart/update.js'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
      })
        .then((r) => (r.ok ? r.json() : null))
        .then((updated) => {
          cartCleanupInFlight = false;
          if (!updated) return;
          const drawerEl = getCartDrawer();
          if (drawerEl && typeof drawerEl.refreshDrawer === 'function') {
             // Silently update the state without triggering a full re-render
             fetchFreshCart().then((cart) => {
                if (cart) syncCartPricingUI(cart);
             });
          }
        })
        .catch(() => {
          cartCleanupInFlight = false;
        });
    };

    if (detail && Array.isArray(detail.discount_applications)) {
      inspect(detail);
      return;
    }

    fetchFreshCart()
      .then((data) => {
        if (data) inspect(data);
      })
      .catch(() => {});
  }

  document.addEventListener('cart:updated', (e) => {
    const updatedCart = e && e.detail && Array.isArray(e.detail.items) ? e.detail : null;
    if (updatedCart) {
      setCurrentCart(updatedCart);
    }
    if (document.getElementById('main-cart-items')?.classList.contains('cart__items--disabled')) return;
    if (Date.now() < qtyUpdateCooldownUntil) return;
    cleanupStaleDiscounts(e && e.detail);
  });

  const drawer = getCartDrawer();
  if (drawer) {
    window.vrvBindDrawerExtras = (options) => bindExtras(drawer, options);
    initDrawerEventDelegation();

    const observer = new MutationObserver(() => {
      if (isBuyNowCheckoutActive()) return;
      if (observer._vrvBindTimer) clearTimeout(observer._vrvBindTimer);
      observer._vrvBindTimer = setTimeout(() => {
        initDrawerEventDelegation();
        bindExtras(drawer, { skipAutoApply: true });
      }, 80);
    });
    observer.observe(drawer, { childList: true, subtree: true });

    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        const page = document.getElementById('CartDrawer-CouponsPage');
        if (page) {
          page.classList.remove('is-open');
          page.hidden = true;
          page.setAttribute('aria-hidden', 'true');
        }
        drawer.classList.remove('is-coupons-open');
      });
    }
  }

  const cartPage = document.getElementById('VrvCartPage');
  if (cartPage) {
    window.vrvBindCartExtras = (options) => bindExtras(cartPage, options);
  }

  document.addEventListener('click', (e) => {
    const couponsBtn = e.target.closest('[data-vrv-open-coupons-page]');
    if (couponsBtn && couponsBtn.closest('cart-drawer')) {
      e.preventDefault();
      e.stopPropagation();
      openCouponsPage();
      return;
    }
    const luxBtn = e.target.closest('[data-lux-open-coupons-drawer]');
    if (luxBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof window.vrvOpenCouponsDrawer === 'function') {
        window.vrvOpenCouponsDrawer(luxBtn);
      }
    }
  });

  function runBuyNowReturnRestore(fromHistory) {
    if (typeof window.vrvMaybeRestoreCartAfterBuyNowReturn === 'function') {
      window.vrvMaybeRestoreCartAfterBuyNowReturn({ fromHistory: Boolean(fromHistory) });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBuyNowReturnRestore);
  } else {
    runBuyNowReturnRestore();
  }

  window.addEventListener('pageshow', (e) => {
    // Any pageshow may be the shopper coming Back from checkout. The restore is
    // a cheap no-op unless this tab has a saved cart, and never runs twice at once.
    runBuyNowReturnRestore(Boolean(e.persisted));

    // FIX (root cause of "cart shows empty/stale count until you refresh"):
    // when a page is restored from the browser's back-forward cache
    // (e.g. user adds items via Move All to Bag, navigates to a product
    // page, then hits Back), the whole JS heap -- including this file's
    // in-memory /cart.js dedupe cache -- is revived exactly as it was when
    // the page was frozen. No script re-runs, so the header bubble and cart
    // drawer keep showing whatever the cart looked like at freeze time,
    // even though a real navigation reload would show the current cart. A
    // real reload is the only thing that previously fixed this. Busting the
    // cache and re-pulling the cart on every bfcache restore makes the
    // restored page match the live cart without needing a manual refresh.
    if (e.persisted) {
      invalidateCartJsCache();
      syncCartDrawerFromServer().catch(() => {});
    }
  });
})();
